<template>
  <b-table
    id="table-product-detail"
    class="line-height striped"
    head-variant="light"
    :empty-text="'ไม่พบข้อมูล'"
    :show-empty="
      items === null || items === undefined || (items && items.length === 0)
    "
    :striped="false"
    :bordered="true"
    :items="items"
    v-bind:fields="
      dataPermissions.find(f => f.name === 'skus').isEditable === true
        ? fields
        : fields.filter(f => f.key !== 'successRate')
    "
  >
    <template v-slot:cell(index)="data">
      <div :id="'row-product-' + data.index">
        {{ (data.index + 1) | number }}
      </div>
    </template>
    <template v-slot:cell(mechanic_1)="data">
      <div>
        {{
          data.item.skuModel.mechanics[0]
            ? data.item.skuModel.mechanics[0].value.display_name.en ==
              data.item.skuModel.mechanics[0].value.display_name.th
              ? data.item.skuModel.mechanics[0].value.display_name.th
              : data.item.skuModel.mechanics[0].value.display_name.th +
                ' : ' +
                data.item.skuModel.mechanics[0].value.display_name.en
            : ''
        }}
      </div>
    </template>
    <template v-slot:cell(mechanic_2)="data">
      <div>
        {{
          data.item.skuModel.mechanics[1]
            ? data.item.skuModel.mechanics[1].value.display_name.en ==
              data.item.skuModel.mechanics[1].value.display_name.th
              ? data.item.skuModel.mechanics[1].value.display_name.th
              : data.item.skuModel.mechanics[1].value.display_name.th +
                ' : ' +
                data.item.skuModel.mechanics[1].value.display_name.en
            : ''
        }}
      </div>
    </template>
    <template v-slot:cell(mechanic_3)="data">
      <div>
        {{
          data.item.skuModel.mechanics[2]
            ? data.item.skuModel.mechanics[2].value.display_name.en ==
              data.item.skuModel.mechanics[2].value.display_name.th
              ? data.item.skuModel.mechanics[2].value.display_name.th
              : data.item.skuModel.mechanics[2].value.display_name.th +
                ' : ' +
                data.item.skuModel.mechanics[2].value.display_name.en
            : ''
        }}
      </div>
    </template>
    <template v-slot:cell(mechanic_4)="data">
      <div>
        {{
          data.item.skuModel.mechanics[3]
            ? data.item.skuModel.mechanics[3].value.display_name.en ==
              data.item.skuModel.mechanics[3].value.display_name.th
              ? data.item.skuModel.mechanics[3].value.display_name.th
              : data.item.skuModel.mechanics[3].value.display_name.th +
                ' : ' +
                data.item.skuModel.mechanics[3].value.display_name.en
            : ''
        }}
      </div>
    </template>
    <template v-slot:cell(successRate)="row">
      <div class="text-center">
        <PercentageCircle
          :percent="row.item.successRate"
          active-color="orange"
          complete-color="green"
          @click="reloadPercent(row, row.index)"
        />
      </div>
    </template>
    <template #cell(action)="row">
      <button
        class="btn btn-sm btn-info"
        type="button"
        @click="onClickMore(row, row.index)"
      >
        {{ row.detailsShowing ? 'Hide' : 'More' }}
        <i
          :class="row.detailsShowing ? 'bx bx-caret-down' : 'bx bx-caret-right'"
          title="More Detail"
        ></i>
      </button>
      <button
        v-if="dataPermissions.find(f => f.name === 'skus').isEditable === true"
        type="button"
        class="btn btn-sm btn-danger"
        v-on:click="onDelete(row.index)"
      >
        <i class="bx bx-trash" />Delete
      </button>
    </template>
    <template #row-details="row">
      <validationObserver :ref="`componentForm_${row.index}`" tag="form">
        <div class="card card-odd">
          <div class="card-body">
            <h4
              class="card-title mb-3"
              :ref="`componentForm_${row.index}_card`"
            >
              #{{ row.index + 1 }}
            </h4>
            <!-- SKU Code -->
            <div class="card" :ref="`componentForm_${row.index}_SKUCode`">
              <div class="card-body border">
                <h4
                  class="card-title card-collapse pointer"
                  @click="
                    collapseStates[row.index].SKUCode = !collapseStates[
                      row.index
                    ].SKUCode
                  "
                >
                  SKU Code
                  <span class="icon-collapse">
                    <button class="btn-icon-collapse" type="button">
                      <template>
                        <i
                          v-if="collapseStates[row.index].SKUCode"
                          class="dripicons-minus"
                        />
                        <i v-else class="dripicons-plus" />
                      </template>
                    </button>
                  </span>
                </h4>
                <b-collapse
                  id="collapse-sku"
                  v-model="collapseStates[row.index].SKUCode"
                >
                  <div class="pt-3">
                    <div class="row">
                      <div class="col-12">
                        <div class="border-top pb-4"></div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div
                          v-if="userInfo.user_type === 'Operator'"
                          class="form-row form-group"
                        >
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >รหัสสินค้า (OFM)</label
                          >
                          <div class="col-lg-9 col-xl-9">
                            <div class="row">
                              <div class="col-4">
                                  <input
                                    type="text"
                                    class="form-control"
                                    disabled
                                    v-model="
                                      row.item.skuModel.sku_codes.find(
                                        f => f.type === 'OFM'
                                      ).code
                                    "
                                  />
                              </div>
                              <div class="col-4 col-form-label">
                                <label
                                v-if="userInfo.user_type === 'Operator'"
                                class=""
                                >รหัสสินค้า (B2S)</label
                              >
                              <i
                              class="ml-1 bx bx-info-circle align-middle absolute text-grey f-18"
                              id="tooltip-factor-sku_codes-jda-b2s"
                            />
                            <b-tooltip
                              target="tooltip-factor-sku_codes-jda-b2s"
                              placement="right"
                              variant="info"
                              >รหัสต้องตรงกับที่ระบุในระบบ JDA B2S</b-tooltip
                            >
                              </div>
                              <div class="col-4">
                                <div class="input-group check-length">
                                  <validationProvider
                                    style="width:100%"
                                    v-slot="{ errors }"
                                    :rules=" 
                                          (business_unit.some(w => w == 'B2S') &&
                                          row.item.skuModel.sku_codes.find(
                                            f => f.type === 'B2S'
                                          ).code == '' ) && vendor_type == 'OFMStock'
                                      ?
                                      {
                                        dynamicRequired: ['กรุณาระบุข้อมูล'],
                                      } : {}">
                                    <input
                                      type="text"
                                      class="form-control"
                                      :class="{ 'is-invalid': errors.length }"
                                      maxlength="7"
                                      v-model="
                                        row.item.skuModel.sku_codes.find(
                                          f => f.type === 'B2S'
                                        ).code
                                      "
                                      :disabled="
                                       (dataPermissions.find(
                                          f => f.name === 'sku_codes_jda'
                                        ).isEditable === false || vendor_type === 'DropShip')
                                      "
                                    />
                                    <span
                                    v-if="errors && errors.length"
                                    class="validate-invalid bt-22"
                                    >
                                      {{ errors[0] }}
                                    </span>
                                  </validationProvider>
                                  <span
                                    v-if="
                                      row.item.skuModel.sku_codes.some(
                                        f => f.type === 'B2S'
                                      ) &&
                                        row.item.skuModel.sku_codes.find(
                                          f => f.type === 'B2S'
                                        ).code
                                    "
                                    class="badge input-validate-length"
                                    :class="{
                                      'badge-success':
                                        row.item.skuModel.sku_codes.find(
                                          f => f.type === 'B2S'
                                        ).code.length !== 7,
                                      'badge-danger':
                                        row.item.skuModel.sku_codes.find(
                                          f => f.type === 'B2S'
                                        ).code.length === 7,
                                    }"
                                    >{{
                                      row.item.skuModel.sku_codes.find(
                                        f => f.type === 'B2S'
                                      ).code.length
                                    }}/7
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="userInfo.user_type === 'Operator'"
                          class="form-row form-group"
                        >
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >รหัสสินค้า (JDA)
                            <i
                              class="ml-1 bx bx-info-circle align-middle absolute text-grey f-18"
                              id="tooltip-factor-sku_codes-jda"
                            />
                            <b-tooltip
                              target="tooltip-factor-sku_codes-jda"
                              placement="right"
                              variant="info"
                              >รหัสต้องตรงกับที่ระบุในระบบ JDA</b-tooltip
                            >
                          </label>
                          <div class="col-lg-9 col-xl-9">
                            <div class="row">
                              <div class="col-4">
                                <div class="input-group check-length">
                                  <input
                                    type="text"
                                    class="form-control"
                                    maxlength="6"
                                    v-model="
                                      row.item.skuModel.sku_codes.find(
                                        f => f.type === 'JDA'
                                      ).code
                                    "
                                    :disabled="
                                      (dataPermissions.find(
                                        f => f.name === 'sku_codes_jda'
                                      ).isEditable === false ||
                                       vendor_type === 'DropShip')
                                    "
                                  />
                                  <span
                                    v-if="
                                      row.item.skuModel.sku_codes.some(
                                        f => f.type === 'JDA'
                                      ) &&
                                        row.item.skuModel.sku_codes.find(
                                          f => f.type === 'JDA'
                                        ).code
                                    "
                                    class="badge input-validate-length"
                                    :class="{
                                      'badge-success':
                                        row.item.skuModel.sku_codes.find(
                                          f => f.type === 'JDA'
                                        ).code.length !== 6,
                                      'badge-danger':
                                        row.item.skuModel.sku_codes.find(
                                          f => f.type === 'JDA'
                                        ).code.length === 6,
                                    }"
                                    >{{
                                      row.item.skuModel.sku_codes.find(
                                        f => f.type === 'JDA'
                                      ).code.length
                                    }}/6
                                  </span>
                                </div>
                              </div>
                              <label
                                v-if="userInfo.user_type === 'Operator'"
                                class="col-4 col-form-label"
                                >รหัส CPC</label
                              >
                              <div
                                v-if="userInfo.user_type === 'Operator'"
                                class="col-4"
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  disabled
                                  v-model="
                                    row.item.skuModel.sku_codes.find(
                                      f => f.type === 'CPC'
                                    ).code
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-row form-group">
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >รหัสสินค้าของผู้ขาย</label
                          >
                          <div class="col-lg-9 col-xl-9">
                            <div class="row">
                              <div class="col-4">
                                <div class="input-group check-length">
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="
                                      row.item.skuModel.sku_codes.find(
                                        f => f.type === 'Vendor'
                                      ).code
                                    "
                                    maxlength="30"
                                    :disabled="
                                      dataPermissions.find(
                                        f => f.name === 'sku_codes'
                                      ).isEditable === false
                                    "
                                  />
                                  <span
                                    v-if="
                                      row.item.skuModel.sku_codes.some(
                                        f => f.type === 'Vendor'
                                      ) &&
                                        row.item.skuModel.sku_codes.find(
                                          f => f.type === 'Vendor'
                                        ).code
                                    "
                                    class="badge input-validate-length"
                                    :class="{
                                      'badge-success':
                                        row.item.skuModel.sku_codes.find(
                                          f => f.type === 'Vendor'
                                        ).code.length !== 30,
                                      'badge-danger':
                                        row.item.skuModel.sku_codes.find(
                                          f => f.type === 'Vendor'
                                        ).code.length === 30,
                                    }"
                                    >{{
                                      row.item.skuModel.sku_codes.find(
                                        f => f.type === 'Vendor'
                                      ).code.length
                                    }}/30
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-row form-group">
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >Vendor Barcode</label
                          >
                          <div class="col-lg-9 col-xl-9">
                            <div class="row">
                              <div class="col-4">
                                <div class="input-group check-length">
                                  <input
                                    type="text"
                                    class="form-control"
                                    @keydown="validateNum($event)"
                                    v-model="
                                      row.item.skuModel.barcodes.find(
                                        f => f.type === 'Vendor'
                                      ).barcode
                                    "
                                    @input="
                                      setOFMBarcodeFromVendorBarcode(row.item)
                                    "
                                    maxlength="20"
                                    :disabled="
                                      dataPermissions.find(
                                        f => f.name === 'sku_codes'
                                      ).isEditable === false
                                    "
                                  />
                                  <span
                                    v-if="
                                      row.item.skuModel.barcodes.find(
                                        f => f.type === 'Vendor'
                                      ).barcode
                                    "
                                    class="badge input-validate-length"
                                    :class="{
                                      'badge-success':
                                        row.item.skuModel.barcodes.find(
                                          f => f.type === 'Vendor'
                                        ).barcode.length !== 20,
                                      'badge-danger':
                                        row.item.skuModel.barcodes.find(
                                          f => f.type === 'Vendor'
                                        ).barcode.length === 20,
                                    }"
                                    >{{
                                      row.item.skuModel.barcodes.find(
                                        f => f.type === 'Vendor'
                                      ).barcode.length
                                    }}/20
                                  </span>
                                </div>
                              </div>
                              <label
                                v-if="userInfo.user_type === 'Operator'"
                                class="col-4 col-form-label"
                                >OFM Barcode</label
                              >
                              <div
                                v-if="userInfo.user_type === 'Operator'"
                                class="col-4"
                              >
                                <validationProvider
                                  v-slot="{ errors }"
                                  :name="`productsku_barcodes_ofm`"
                                  :rules="
                                    row.item.skuModel.other
                                      .is_default_barcode === false
                                      ? {
                                          dynamicRequired: [
                                            'กรุณาระบุข้อมูล หรือเลือกให้ระบบสร้าง barcode ให้',
                                          ],
                                        }
                                      : {}
                                  "
                                >
                                  <div class="input-group check-length">
                                    <input
                                      :id="
                                        `productsku_barcodes_ofm_${row.index}`
                                      "
                                      type="text"
                                      class="form-control"
                                      v-model="
                                        row.item.skuModel.barcodes.find(
                                          f => f.type === 'OFM'
                                        ).barcode
                                      "
                                      maxlength="20"
                                      :disabled="
                                        row.item.skuModel.other
                                          .is_default_barcode ||
                                          dataPermissions.find(
                                            f => f.name === 'sku_codes'
                                          ).isEditable === false
                                      "
                                      :class="{
                                        'is-invalid': errors && errors.length,
                                      }"
                                    />
                                    <span
                                      v-if="
                                        row.item.skuModel.barcodes.find(
                                          f => f.type === 'OFM'
                                        ).barcode
                                      "
                                      class="badge input-validate-length"
                                      :class="{
                                        'badge-success':
                                          row.item.skuModel.barcodes.find(
                                            f => f.type === 'OFM'
                                          ).barcode.length !== 20,
                                        'badge-danger':
                                          row.item.skuModel.barcodes.find(
                                            f => f.type === 'OFM'
                                          ).barcode.length === 20,
                                      }"
                                      >{{
                                        row.item.skuModel.barcodes.find(
                                          f => f.type === 'OFM'
                                        ).barcode.length
                                      }}/20
                                    </span>
                                  </div>
                                  <div
                                    v-if="errors && errors.length"
                                    class="validate-invalid bt-22"
                                  >
                                    <span>{{ errors[0] }}</span>
                                  </div>
                                </validationProvider>
                                <b-form-checkbox
                                  v-model="
                                    row.item.skuModel.other.is_default_barcode
                                  "
                                  class="mt-3 f-12"
                                  :disabled="
                                    dataPermissions.find(
                                      f => f.name === 'sku_codes'
                                    ).isEditable === false
                                  "
                                  @change="
                                    onChangeIsDefaultBarcode($event, row.item)
                                  "
                                  >ให้ระบบสร้าง barcode ให้</b-form-checkbox
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
            <!-- SKU information -->
            <div
              class="card"
              :ref="`componentForm_${row.index}_SKUInformation`"
            >
              <div class="card-body border">
                <h4
                  class="card-title card-collapse pointer"
                  @click="
                    collapseStates[row.index].SKUInformation = !collapseStates[
                      row.index
                    ].SKUInformation
                  "
                >
                  SKU Infomation
                  <span class="icon-collapse">
                    <button class="btn-icon-collapse" type="button">
                      <template>
                        <i
                          v-if="collapseStates[row.index].SKUInformation"
                          class="dripicons-minus"
                        />
                        <i v-else class="dripicons-plus" />
                      </template>
                    </button>
                  </span>
                </h4>
                <b-collapse
                  id="collapse-sku-infomation"
                  v-model="collapseStates[row.index].SKUInformation"
                >
                  <div class="pt-3">
                    <div class="row">
                      <div class="col-12">
                        <div class="border-top pb-4"></div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="form-row">
                          <label class="col-lg-4 col-xl-3"> </label>
                          <label class="col-sm-4 text-center">
                            ข้อมูลภาษาไทย
                          </label>
                          <label class="col-sm-4 text-center">
                            ข้อมูลภาษาอังกฤษ
                          </label>
                        </div>

                        <div
                          v-for="(field, index) in row.item.skuModel
                            .mechanics !== null &&
                          row.item.skuModel.mechanics !== undefined
                            ? row.item.skuModel.mechanics
                            : []"
                          :key="index"
                        >
                          <div class="form-row form-group">
                            <label
                              class="col-lg-4 col-xl-3 col-form-label"
                              :for="
                                `skuInformationTH_${row.item.index}_${index}`
                              "
                              >{{ field.display_name.th }}
                            </label>
                            <div class="col-sm-4">
                              <div role="group" class="input-group">
                                <div class="input-group-prepend">
                                  <div class="input-group-text">TH</div>
                                </div>
                                <input
                                  :id="
                                    `skuInformationTH_${row.item.index}_${index}`
                                  "
                                  :name="
                                    `skuInformationTH_${row.item.index}_${index}`
                                  "
                                  type="text"
                                  class="form-control"
                                  v-model="
                                    row.item.skuModel.mechanics[index].value
                                      .display_name.th
                                  "
                                  disabled
                                />
                              </div>
                            </div>
                            <div class="col-sm-4">
                              <div role="group" class="input-group">
                                <div class="input-group-prepend">
                                  <div class="input-group-text">EN</div>
                                </div>
                                <input
                                  :id="
                                    `skuInformationEN_${row.item.index}_${index}`
                                  "
                                  :name="
                                    `skuInformationEN_${row.item.index}_${index}`
                                  "
                                  type="text"
                                  class="form-control"
                                  v-model="
                                    row.item.skuModel.mechanics[index].value
                                      .display_name.en
                                  "
                                  :disabled="
                                    row.item.skuModel.mechanics[index].type ==
                                      'Database' ||
                                      dataPermissions.find(
                                        f => f.name === 'mechanics'
                                      ).isEditable === false
                                  "
                                  @change="
                                    onChangeDefault(
                                      row.item.skuModel.mechanics[index].type ==
                                        'FreeText',
                                      row.item,
                                      'All'
                                    )
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
            <!-- Product Name -->
            <div class="card" :ref="`componentForm_${row.index}_ProductName`">
              <div class="card-body border">
                <h4
                  class="card-title card-collapse pointer"
                  @click="
                    collapseStates[row.index].ProductName = !collapseStates[
                      row.index
                    ].ProductName
                  "
                >
                  Product Name
                  <span class="icon-collapse">
                    <button class="btn-icon-collapse" type="button">
                      <template>
                        <i
                          v-if="collapseStates[row.index].ProductName"
                          class="dripicons-minus"
                        />
                        <i v-else class="dripicons-plus" />
                      </template>
                    </button>
                  </span>
                </h4>
                <b-collapse
                  id="collapse-pname"
                  v-model="collapseStates[row.index].ProductName"
                >
                  <div class="pt-3">
                    <div class="row">
                      <div class="col-12">
                        <div class="border-top pb-4"></div>
                      </div>
                    </div>
                    <div class="row" v-if="row.item.skuModel.product_names">
                      <div class="col-12">
                        <div
                          class="form-row form-group"
                          v-if="
                            userInfo.user_type === 'Operator' &&
                              row.item.skuModel.product_names.some(
                                f => f.type == 'Document'
                              )
                          "
                        >
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >ชื่อสินค้า (สำหรับเอกสาร)
                            <i
                              class="ml-1 bx bx-info-circle align-middle absolute text-grey f-18"
                              id="product_name_doc"
                            />
                            <b-tooltip
                              target="product_name_doc"
                              placement="right"
                              variant="info"
                            >
                              Format [th] ชื่อสินค้าตั้งต้น เว้นวรรค แบรนด์
                              เว้นวรรค รุ่น เว้นวรรค สี เว้นวรรค ขนาด
                              <p />
                              Format [en] แบรนด์ เว้นวรรค ชื่อสินค้าตั้งต้น
                              เว้นวรรค รุ่น เว้นวรรค ขนาด เว้นวรรค สี</b-tooltip
                            >
                          </label>
                          <div class="col-sm-9">
                            <validationProvider
                              v-slot="{ errors }"
                              :name="`productsku_product_names_document_th`"
                              :rules="{
                                validateSingleQuote: true,
                              }"
                            >
                              <div
                                role="group"
                                class="input-group check-length"
                              >
                                <div class="input-group-prepend">
                                  <div class="input-group-text">TH</div>
                                </div>
                                <input
                                  :id="
                                    `productsku_product_names_document_th_${row.index}`
                                  "
                                  v-model="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Document'
                                    ).display_name.th
                                  "
                                  type="text"
                                  class="form-control"
                                  maxlength="55"
                                  :class="{
                                    'is-invalid': errors && errors.length,
                                  }"
                                  :disabled="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Document'
                                    ).isDefault ||
                                      dataPermissions.find(
                                        f => f.name === 'product_names'
                                      ).isEditable === false
                                  "
                                />
                                <span
                                  v-if="
                                    row.item.skuModel.product_names.some(
                                      f => f.type == 'Document'
                                    )
                                  "
                                  class="badge input-validate-length"
                                  :class="{
                                    'badge-success':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'Document'
                                      ).display_name.th.length !== 55,
                                    'badge-danger':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'Document'
                                      ).display_name.th.length === 55,
                                  }"
                                  >{{
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Document'
                                    ).display_name.th.length
                                  }}/55</span
                                >
                                <div
                                  v-if="errors && errors.length"
                                  class="validate-invalid bt-22"
                                >
                                  <span>{{ errors[0] }}</span>
                                </div>
                              </div>
                            </validationProvider>
                          </div>
                        </div>
                        <div
                          class="form-row form-group"
                          v-if="
                            userInfo.user_type === 'Operator' &&
                              row.item.skuModel.product_names.some(
                                f => f.type == 'Document'
                              )
                          "
                        >
                          <label
                            class="col-lg-3 col-xl-3 col-form-label"
                          ></label>
                          <div class="col-sm-9">
                            <validationProvider
                              v-slot="{ errors }"
                              :name="`productsku_product_names_document_en`"
                              :rules="{
                                validateSingleQuote: true,
                              }"
                            >
                              <div
                                role="group"
                                class="input-group check-length"
                              >
                                <div class="input-group-prepend">
                                  <div class="input-group-text">EN</div>
                                </div>
                                <input
                                  :id="
                                    `productsku_product_names_document_en_${row.index}`
                                  "
                                  v-model="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Document'
                                    ).display_name.en
                                  "
                                  type="text"
                                  class="form-control"
                                  maxlength="55"
                                  :class="{
                                    'is-invalid': errors && errors.length,
                                  }"
                                  :disabled="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Document'
                                    ).isDefault ||
                                      dataPermissions.find(
                                        f => f.name === 'product_names'
                                      ).isEditable === false
                                  "
                                />
                                <span
                                  v-if="
                                    row.item.skuModel.product_names.some(
                                      f => f.type == 'Document'
                                    )
                                  "
                                  class="badge input-validate-length"
                                  :class="{
                                    'badge-success':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'Document'
                                      ).display_name.en.length !== 55,
                                    'badge-danger':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'Document'
                                      ).display_name.en.length === 55,
                                  }"
                                  >{{
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Document'
                                    ).display_name.en.length
                                  }}/55</span
                                >
                                <div
                                  v-if="errors && errors.length"
                                  class="validate-invalid bt-22"
                                >
                                  <span>{{ errors[0] }}</span>
                                </div>
                              </div>
                            </validationProvider>
                            <b-form-checkbox
                              class="mt-2 f-12"
                              v-model="
                                row.item.skuModel.product_names.find(
                                  f => f.type == 'Document'
                                ).isDefault
                              "
                              @change="
                                onChangeDefault($event, row.item, 'Document')
                              "
                              :disabled="
                                dataPermissions.find(
                                  f => f.name === 'product_names'
                                ).isEditable === false
                              "
                              >Default Product Name</b-form-checkbox
                            >
                          </div>
                        </div>
                        <div
                          class="form-row form-group"
                          v-if="
                            row.item.skuModel.product_names.some(
                              f => f.type == 'Online'
                            )
                          "
                        >
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >ชื่อสินค้า (สำหรับแสดงหน้าเว็บ)
                            <i
                              class="ml-1 bx bx-info-circle align-middle absolute text-grey f-18"
                              id="product_name_web"
                            />
                            <b-tooltip
                              target="product_name_web"
                              placement="right"
                              variant="info"
                            >
                              Format [th] ชื่อสินค้าตั้งต้น เว้นวรรค แบรนด์
                              เว้นวรรค รุ่น เว้นวรรค สี เว้นวรรค ขนาด เว้นวรรค
                              หน่วยขาย
                              <p />
                              Format [en] แบรนด์ เว้นวรรค ชื่อสินค้าตั้งต้น
                              เว้นวรรค รุ่น เว้นวรรค สี เว้นวรรค ขนาด เว้นวรรค
                              หน่วยขาย
                            </b-tooltip>
                          </label>
                          <div class="col-sm-9">
                            <validationProvider
                              v-slot="{ errors }"
                              :name="`productsku_product_names_online_th`"
                              :rules="{
                                validateSingleQuote: true,
                              }"
                            >
                              <div
                                role="group"
                                class="input-group check-length"
                              >
                                <div class="input-group-prepend">
                                  <div class="input-group-text">TH</div>
                                </div>
                                <input
                                  :id="
                                    `productsku_product_names_online_th_${row.index}`
                                  "
                                  v-model="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Online'
                                    ).display_name.th
                                  "
                                  type="text"
                                  class="form-control"
                                  maxlength="200"
                                  :class="{
                                    'is-invalid': errors && errors.length,
                                  }"
                                  :disabled="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Online'
                                    ).isDefault ||
                                      dataPermissions.find(
                                        f => f.name === 'product_names_online'
                                      ).isEditable === false
                                  "
                                />
                                <span
                                  v-if="
                                    row.item.skuModel.product_names.some(
                                      f => f.type == 'Online'
                                    )
                                  "
                                  class="badge input-validate-length"
                                  :class="{
                                    'badge-success':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'Online'
                                      ).display_name.th.length !== 200,
                                    'badge-danger':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'Online'
                                      ).display_name.th.length === 200,
                                  }"
                                  >{{
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Online'
                                    ).display_name.th.length
                                  }}/200</span
                                >
                                <div
                                  v-if="errors && errors.length"
                                  class="validate-invalid bt-22"
                                >
                                  <span>{{ errors[0] }}</span>
                                </div>
                              </div>
                            </validationProvider>
                          </div>
                        </div>
                        <div
                          class="form-row form-group"
                          v-if="
                            row.item.skuModel.product_names.some(
                              f => f.type == 'Online'
                            )
                          "
                        >
                          <label
                            class="col-lg-3 col-xl-3 col-form-label"
                          ></label>
                          <div class="col-sm-9">
                            <validationProvider
                              v-slot="{ errors }"
                              :name="`productsku_product_names_online_en`"
                              :rules="{
                                validateSingleQuote: true,
                              }"
                            >
                              <div
                                role="group"
                                class="input-group check-length"
                              >
                                <div class="input-group-prepend">
                                  <div class="input-group-text">EN</div>
                                </div>
                                <input
                                  :id="
                                    `productsku_product_names_online_en_${row.index}`
                                  "
                                  v-model="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Online'
                                    ).display_name.en
                                  "
                                  type="text"
                                  class="form-control"
                                  maxlength="200"
                                  :class="{
                                    'is-invalid': errors && errors.length,
                                  }"
                                  :disabled="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Online'
                                    ).isDefault ||
                                      dataPermissions.find(
                                        f => f.name === 'product_names_online'
                                      ).isEditable === false
                                  "
                                />
                                <span
                                  v-if="
                                    row.item.skuModel.product_names.some(
                                      f => f.type == 'Online'
                                    )
                                  "
                                  class="badge input-validate-length"
                                  :class="{
                                    'badge-success':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'Online'
                                      ).display_name.en.length !== 200,
                                    'badge-danger':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'Online'
                                      ).display_name.en.length === 200,
                                  }"
                                  >{{
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Online'
                                    ).display_name.en.length
                                  }}/200</span
                                >
                                <div
                                  v-if="errors && errors.length"
                                  class="validate-invalid bt-22"
                                >
                                  <span>{{ errors[0] }}</span>
                                </div>
                              </div>
                            </validationProvider>
                            <b-form-checkbox
                              class="mt-2 f-12"
                              v-model="
                                row.item.skuModel.product_names.find(
                                  f => f.type == 'Online'
                                ).isDefault
                              "
                              @change="
                                onChangeDefault($event, row.item, 'Online')
                              "
                              :disabled="
                                dataPermissions.find(
                                  f => f.name === 'product_names_online'
                                ).isEditable === false
                              "
                              >Default Product Name</b-form-checkbox
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
            <!-- Price -->
            <div class="card" :ref="`componentForm_${row.index}_Price`">
              <div class="card-body border">
                <h4
                  class="card-title card-collapse pointer"
                  @click="
                    collapseStates[row.index].Price = !collapseStates[row.index]
                      .Price
                  "
                >
                  Price
                  <span class="icon-collapse">
                    <button class="btn-icon-collapse" type="button">
                      <template>
                        <i
                          v-if="collapseStates[row.index].Price"
                          class="dripicons-minus"
                        />
                        <i v-else class="dripicons-plus" />
                      </template>
                    </button>
                  </span>
                </h4>
                <b-collapse
                  id="collapse-sku-price"
                  v-model="collapseStates[row.index].Price"
                >
                  <div class="pt-3">
                    <div class="row">
                      <div class="col-12">
                        <div class="border-top pb-4"></div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="row mb-4">
                          <div class="col-1 d-none d-sm-none d-md-block"></div>
                          <div class="col">
                            <div class="form-row form-group">
                              <label class="col-lg-3 col-xl-3 col-form-label"
                                >สินค้าคิดภาษี (Vat)</label
                              >
                              <div class="col-sm-8 col-form-label">
                                <switches
                                  v-model="row.item.skuModel.other.is_vat"
                                  type-bold="true"
                                  color="info"
                                  class="switch-inner-label custom-switches switches-small switches-margin-top"
                                  text-enabled="Yes"
                                  text-disabled="No"
                                  :disabled="
                                    dataPermissions.find(
                                      f => f.name === 'prices'
                                    ).isEditable === false
                                  "
                                  @input="onCalculatePrice(row.item)"
                                ></switches>
                              </div>
                            </div>
                            <div
                              v-if="userInfo.user_type === 'Operator'"
                              class="form-row form-group"
                            >
                              <label
                                class="col-lg-3 col-xl-3 col-form-label"
                                :id="
                                  `productsku_other_fix_price_period_${row.index}`
                                "
                                >ยืนราคา</label
                              >
                              <div class="col">
                                <div class="row">
                                  <div class="col-4">
                                    <validationProvider
                                      v-slot="{ errors }"
                                      :name="
                                        `productsku_other_fix_price_period`
                                      "
                                      :rules="{
                                        dynamicRequired: ['กรุณาเลือก'],
                                      }"
                                    >
                                      <multiselect
                                        v-model="
                                          row.item.skuModel.other
                                            .fix_price_period
                                        "
                                        :options="
                                          options_fix_price_period.map(
                                            type => type.value
                                          )
                                        "
                                        :custom-label="
                                          label =>
                                            options_fix_price_period.find(
                                              x => x.value == label
                                            ).text
                                        "
                                        :show-labels="false"
                                        :disabled="
                                          dataPermissions.find(
                                            f => f.name === 'prices'
                                          ).isEditable === false
                                        "
                                        placeholder="เลือกการยืนราคา"
                                        :class="{
                                          'is-invalid': errors && errors.length,
                                        }"
                                      />
                                      <span
                                        v-if="
                                          is_free === false &&
                                            errors &&
                                            errors.length
                                        "
                                        class="validate-invalid bt-22"
                                      >
                                        {{ errors[0] }}
                                      </span>
                                    </validationProvider>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mb-4">
                          <div class="col-12">
                            <h4 class="card-title mb-4">Gross Profit Margin</h4>
                          </div>
                          <div class="col-1 d-none d-sm-none d-md-block"></div>
                          <div class="col">
                            <div class="form-row form-group">
                              <label class="col-lg-3 col-xl-3 col-form-label"
                                >GP Standard (%)</label
                              >
                              <div class="col">
                                <div class="row">
                                  <div class="col-4">
                                    <!-- <input
                                      v-model="
                                        row.item.skuModel.gross_profit
                                          .gp_standard
                                      "
                                      type="number"
                                      class="form-control text-right"
                                      disabled
                                    /> -->
                                    <InputFormatDecimal
                                      v-model="
                                        row.item.skuModel.gross_profit
                                          .gp_standard
                                      "
                                      disabled
                                    />
                                  </div>
                                  <label class="col-4 col-form-label"
                                    >Commission Rate (%)</label
                                  >
                                  <div class="col-4">
                                    <validationProvider
                                      v-slot="{ errors }"
                                      :name="`product_other_commission_rate`"
                                      :rules="{
                                        validateGreaterThanInputNumber: [
                                          {
                                            max: '100',
                                            msg: 'ตัวเลขต้องน้อยกว่า 100',
                                          },
                                        ],
                                        dynamicRequired: ['กรุณาระบุข้อมูล'],
                                      }"
                                    >
                                      <!-- <input
                                        :id="
                                          `product_other_commission_rate_${row.index}`
                                        "
                                        v-model="
                                          row.item.skuModel.other
                                            .commission_rate
                                        "
                                        type="number"
                                        class="form-control text-right"
                                        :disabled="
                                          vendor_type == 'OFMStock' ||
                                            dataPermissions.find(
                                              f => f.name === 'prices'
                                            ).isEditable === false
                                        "
                                        :class="{
                                          'is-invalid': errors && errors.length,
                                        }"
                                        @change="onCalculatePrice(row.item)"
                                      /> -->
                                      <InputFormatDecimal
                                        :name="
                                          `product_other_commission_rate_${row.index}`
                                        "
                                        v-model="
                                          row.item.skuModel.other
                                            .commission_rate
                                        "
                                        disabled
                                        :isError="errors && errors.length > 0"
                                        @change="onCalculatePrice(row.item)"
                                      />
                                      <span
                                        v-if="errors && errors.length"
                                        class="validate-invalid bt-22"
                                      >
                                        {{ errors[0] }}
                                      </span>
                                    </validationProvider>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-row form-group">
                              <label class="col-lg-3 col-xl-3 col-form-label"
                                >GP Rate (%)</label
                              >
                              <div class="col">
                                <div class="row">
                                  <div class="col-4">
                                    <!-- <input
                                      v-model="
                                        row.item.skuModel.gross_profit.gp_rate
                                      "
                                      type="number"
                                      class="form-control text-right"
                                      disabled
                                    /> -->
                                    <InputFormatDecimal
                                      v-model="
                                        row.item.skuModel.gross_profit.gp_rate
                                      "
                                      disabled
                                    />
                                  </div>
                                  <label class="col-4 col-form-label"
                                    >GP Amount</label
                                  >
                                  <div class="col-4">
                                    <!-- <input
                                      v-model="
                                        row.item.skuModel.gross_profit.gp_amount
                                      "
                                      type="number"
                                      class="form-control text-right"
                                      disabled
                                    /> -->

                                    <InputFormatDecimal
                                      v-model="
                                        row.item.skuModel.gross_profit.gp_amount
                                      "
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mb-4">
                          <div class="col-12">
                            <h4 class="card-title mb-4">Cost</h4>
                          </div>
                          <div class="col-1 d-none d-sm-none d-md-block"></div>
                          <div class="col">
                            <div
                              v-if="
                                userInfo.user_type === 'Operator' ||
                                  (userInfo.user_type === 'Vendor' &&
                                    vendor_type === 'OFMStock')
                              "
                              class="form-row form-group"
                            >
                              <label class="col-lg-3 col-xl-3 col-form-label"
                                >ส่วนลดในตัว (%)</label
                              >
                              <div class="col">
                                <div class="row">
                                  <div class="col-4">
                                    <validationProvider
                                      v-slot="{ errors }"
                                      :name="`product_other_discount_rate`"
                                      :rules="{
                                        dynamicRequired: ['กรุณาระบุข้อมูล'],
                                        validateGreaterThanInputNumber: [
                                          {
                                            max: 100,
                                            msg: 'ตัวเลขต้องน้อยกว่า 100',
                                          },
                                        ],
                                      }"
                                    >
                                      <!-- <input
                                        :id="
                                          `product_other_discount_rate_${row.index}`
                                        "
                                        v-model="
                                          row.item.skuModel.other.discount_rate
                                        "
                                        type="number"
                                        class="form-control text-right"
                                        :disabled="
                                          vendor_type !== 'OFMStock' ||
                                            dataPermissions.find(
                                              f => f.name === 'prices'
                                            ).isEditable === false
                                        "
                                        :class="{
                                          'is-invalid': errors && errors.length,
                                        }"
                                        @change="onCalculatePrice(row.item)"
                                      /> -->

                                      <InputFormatDecimal
                                        :name="
                                          `product_other_discount_rate_${row.index}`
                                        "
                                        v-model="
                                          row.item.skuModel.other.discount_rate
                                        "
                                        :disabled="
                                          vendor_type !== 'OFMStock' ||
                                            dataPermissions.find(
                                              f => f.name === 'prices'
                                            ).isEditable === false
                                        "
                                        :isError="errors && errors.length > 0"
                                        v-on:change="onCalculatePrice(row.item)"
                                      />

                                      <span
                                        v-if="errors && errors.length"
                                        class="validate-invalid bt-22"
                                      >
                                        {{ errors[0] }}
                                      </span>
                                    </validationProvider>
                                  </div>
                                  <label class="col-4 col-form-label"
                                    >ส่วนลดท้ายบิล (%)</label
                                  >
                                  <div class="col-4">
                                    <!-- <input
                                      v-model="discount_rate_1"
                                      type="number"
                                      class="form-control text-right"
                                      disabled
                                    /> -->
                                    <InputFormatDecimal
                                      :value="discount_rate_1"
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-row form-group">
                              <label class="col-lg-3 col-xl-3 col-form-label"
                                >ราคาทุน (Excluding Vat)</label
                              >
                              <div class="col">
                                <div class="row">
                                  <div class="col-4">
                                    <validationProvider
                                      v-slot="{ errors }"
                                      :name="
                                        `product_sku_price_prices_cost_include_vat`
                                      "
                                      :rules="{
                                        validateGreaterThanZero:
                                          is_free === false,
                                        validateGreaterThanInputNumber: [
                                          {
                                            max: '10000000',
                                            msg: 'ตัวเลขต้องน้อยกว่า 10 ล้าน',
                                          },
                                        ],
                                        dynamicRequired: ['กรุณาระบุข้อมูล'],
                                      }"
                                    >
                                      <!-- <input
                                        :id="
                                          `product_sku_price_prices_cost_include_vat_${row.index}`
                                        "
                                        v-model="
                                          row.item.skuModel.prices.find(
                                            f => f.type == 'Cost'
                                          ).exclude_vat
                                        "
                                        type="number"
                                        class="form-control text-right"
                                        :disabled="
                                          vendor_type !== 'OFMStock' ||
                                            dataPermissions.find(
                                              f => f.name === 'prices'
                                            ).isEditable === false
                                        "
                                        :class="{
                                          'is-invalid': errors && errors.length,
                                        }"
                                        @input="
                                          row.item.skuModel.prices.find(
                                            f => f.type == 'Cost'
                                          ).include_vat = row.item.skuModel
                                            .other.is_vat
                                            ? Number(
                                                Number(row.item.skuModel.prices.find(
                                                  f => f.type == 'Cost'
                                                ).exclude_vat).toFixed(2) +  Number(
                                                  (row.item.skuModel.prices.find(
                                                    f => f.type == 'Cost'
                                                  ).exclude_vat *
                                                    vat_rate) /
                                                    100
                                                ).toFixed(2)
                                              ).toFixed(2)
                                            : Number(
                                                row.item.skuModel.prices.find(
                                                  f => f.type == 'Cost'
                                                ).exclude_vat
                                              )
                                        "
                                        @change="onCalculatePrice(row.item)"
                                      /> -->
                                      <InputFormatDecimal
                                        :name="
                                          `product_sku_price_prices_cost_include_vat_${row.index}`
                                        "
                                        v-model="
                                          row.item.skuModel.prices.find(
                                            f => f.type == 'Cost'
                                          ).exclude_vat
                                        "
                                        :disabled="
                                          vendor_type !== 'OFMStock' ||
                                            dataPermissions.find(
                                              f => f.name === 'prices'
                                            ).isEditable === false
                                        "
                                        :isError="errors && errors.length > 0"
                                        @input="
                                          row.item.skuModel.prices.find(
                                            f => f.type == 'Cost'
                                          ).include_vat = row.item.skuModel
                                            .other.is_vat
                                            ? Number(
                                                Number(
                                                  row.item.skuModel.prices.find(
                                                    f => f.type == 'Cost'
                                                  ).exclude_vat
                                                ) +
                                                  Number(
                                                    (Number(
                                                      row.item.skuModel.prices.find(
                                                        f => f.type == 'Cost'
                                                      ).exclude_vat
                                                    ) *
                                                      Number(vat_rate)) /
                                                      100
                                                  )
                                              ).toFixed(2)
                                            : Number(
                                                row.item.skuModel.prices.find(
                                                  f => f.type == 'Cost'
                                                ).exclude_vat
                                              )
                                        "
                                        @change="onCalculatePrice(row.item)"
                                      />
                                      <span
                                        v-if="errors && errors.length"
                                        class="validate-invalid bt-22"
                                      >
                                        {{ errors[0] }}
                                      </span>
                                    </validationProvider>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="userInfo.user_type === 'Operator'"
                              class="form-row form-group mb-4"
                            >
                              <label class="col-lg-3 col-xl-3 col-form-label"
                                >ราคาทุนขาย (Excluding Vat)</label
                              >
                              <div class="col">
                                <div class="row">
                                  <div class="col-4">
                                    <!-- <input
                                      v-model="
                                        row.item.skuModel.gross_profit
                                          .cost_of_sale
                                      "
                                      type="number"
                                      class="form-control text-right"
                                      disabled
                                    /> -->
                                    <InputFormatDecimal
                                      :value="
                                        row.item.skuModel.gross_profit
                                          .cost_of_sale
                                      "
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mb-4">
                          <div class="col-12">
                            <h4 class="card-title mb-4">Sale Price</h4>
                          </div>
                          <div class="col-1 d-none d-sm-none d-md-block"></div>
                          <div class="col">
                            <div class="form-row form-group">
                              <label class="col-lg-3 col-xl-3 col-form-label"
                                >ราคาแนะนำขาย (Including Vat)</label
                              >
                              <div class="col">
                                <div class="row">
                                  <div class="col-4">
                                    <validationProvider
                                      v-slot="{ errors }"
                                      :name="
                                        `product_sku_price_prices_retail_price_include_vat`
                                      "
                                      :rules="{
                                        validateGreaterThanZero:
                                          is_free === false,
                                        validateGreaterThanInputNumber: [
                                          {
                                            max: '10000000',
                                            msg: 'ตัวเลขต้องน้อยกว่า 10 ล้าน',
                                          },
                                        ],
                                        dynamicRequired: [
                                          'กรุณาระบุราคาแนะนำขาย',
                                        ],
                                      }"
                                    >
                                      <!-- <input
                                        :id="
                                          `product_sku_price_prices_retail_price_include_vat_${row.index}`
                                        "
                                        v-model="
                                          row.item.skuModel.prices.find(
                                            f => f.type == 'RetailPrice'
                                          ).include_vat
                                        "
                                        type="number"
                                        class="form-control text-right"
                                        :class="{
                                          'is-invalid': errors && errors.length,
                                        }"
                                        :disabled="
                                          dataPermissions.find(
                                            f => f.name === 'prices'
                                          ).isEditable === false
                                        "
                                        @input="onRetailPriceChange(row.item)"
                                      /> -->

                                      <InputFormatDecimal
                                        :name="
                                          `product_sku_price_prices_retail_price_include_vat_${row.index}`
                                        "
                                        v-model="
                                          row.item.skuModel.prices.find(
                                            f => f.type == 'RetailPrice'
                                          ).include_vat
                                        "
                                        :isError="errors && errors.length > 0"
                                        :disabled="
                                          dataPermissions.find(
                                            f => f.name === 'prices'
                                          ).isEditable === false
                                        "
                                        @input="onRetailPriceChange(row.item)"
                                      />

                                      <span
                                        v-if="
                                          is_free === false &&
                                            errors &&
                                            errors.length
                                        "
                                        class="validate-invalid bt-22"
                                      >
                                        {{ errors[0] }}
                                      </span>
                                    </validationProvider>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="
                                userInfo.user_type === 'Operator' ||
                                  (userInfo.user_type === 'Vendor' &&
                                    vendor_type === 'DropShip')
                              "
                              class="form-row form-group"
                            >
                              <label class="col-lg-3 col-xl-3 col-form-label"
                                >ราคาขาย (Including Vat)</label
                              >
                              <div class="col">
                                <div class="row">
                                  <div class="col-4">
                                    <validationProvider
                                      v-slot="{ errors }"
                                      :name="
                                        `product_sku_price_prices_sale_price_include_vat`
                                      "
                                      :rules="{
                                        validateGreaterThanZero:
                                          is_free === false,
                                        validateGreaterThanInputNumber: [
                                          {
                                            max: '10000000',
                                            msg: 'ตัวเลขต้องน้อยกว่า 10 ล้าน',
                                          },
                                        ],
                                        dynamicRequired: ['กรุณาระบุราคาขาย'],
                                      }"
                                    >
                                      <!-- <input
                                        :id="
                                          `product_sku_price_prices_sale_price_include_vat_${row.index}`
                                        "
                                        v-model="
                                          row.item.skuModel.prices.find(
                                            f => f.type == 'SalePrice'
                                          ).include_vat
                                        "
                                        type="number"
                                        class="form-control text-right"
                                        :class="{
                                          'is-invalid': errors && errors.length,
                                        }"
                                        @change="onCalculatePrice(row.item)"
                                        :disabled="
                                          dataPermissions.find(
                                            f => f.name === 'prices'
                                          ).isEditable === false
                                        "
                                      /> -->

                                      <InputFormatDecimal
                                        :name="
                                          `product_sku_price_prices_sale_price_include_vat_${row.index}`
                                        "
                                        v-model="
                                          row.item.skuModel.prices.find(
                                            f => f.type == 'SalePrice'
                                          ).include_vat
                                        "
                                        :isError="errors && errors.length > 0"
                                        @change="onCalculatePrice(row.item)"
                                        :disabled="
                                          dataPermissions.find(
                                            f => f.name === 'prices'
                                          ).isEditable === false
                                        "
                                      />

                                      <span
                                        v-if="errors && errors.length"
                                        class="validate-invalid bt-22"
                                      >
                                        {{ errors[0] }}
                                      </span>
                                    </validationProvider>
                                  </div>
                                  <label class="col-4 col-form-label"
                                    >ราคาขาย (Excluding Vat)</label
                                  >
                                  <div class="col-4">
                                    <!-- <input
                                      v-model="
                                        row.item.skuModel.prices.find(
                                          f => f.type == 'SalePrice'
                                        ).exclude_vat
                                      "
                                      type="number"
                                      class="form-control text-right"
                                      disabled
                                    /> -->

                                    <InputFormatDecimal
                                      :value="
                                        row.item.skuModel.prices.find(
                                          f => f.type == 'SalePrice'
                                        ).exclude_vat
                                      "
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="userInfo.user_type === 'Operator'"
                              class="form-row form-group"
                            >
                              <label class="col-lg-3 col-xl-3 col-form-label"
                                >MR Point</label
                              >
                              <div class="col">
                                <div class="row">
                                  <div class="col-4">
                                    <input
                                      v-model="row.item.skuModel.other.mr_point"
                                      type="number"
                                      class="form-control text-right"
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="userInfo.user_type === 'Operator'"
                              class="form-row form-group"
                            >
                              <label class="col-lg-3 col-xl-3 col-form-label"
                                >สินค้า Best Deal</label
                              >
                              <div class="col-form-label">
                                <switches
                                  v-model="row.item.skuModel.other.is_best_deal"
                                  type-bold="true"
                                  color="info"
                                  class="switch-inner-label custom-switches switches-small "
                                  text-enabled="Yes"
                                  text-disabled="No"
                                  :disabled="
                                    dataPermissions.find(
                                      f => f.name === 'prices'
                                    ).isEditable === false ||
                                      (basicModel && basicModel.is_best_deal)
                                  "
                                ></switches>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
            <!-- Quantity -->
            <div class="card" :ref="`componentForm_${row.index}_Quantity`">
              <div class="card-body border">
                <h4
                  class="card-title card-collapse pointer"
                  @click="
                    collapseStates[row.index].Quantity = !collapseStates[
                      row.index
                    ].Quantity
                  "
                >
                  Quantity
                  <span class="icon-collapse">
                    <button class="btn-icon-collapse" type="button">
                      <template>
                        <i
                          v-if="collapseStates[row.index].Quantity"
                          class="dripicons-minus"
                        />
                        <i v-else class="dripicons-plus" />
                      </template>
                    </button>
                  </span>
                </h4>
                <b-collapse
                  id="collapse-sku"
                  v-model="collapseStates[row.index].Quantity"
                >
                  <div class="pt-3">
                    <div class="row">
                      <div class="col-12">
                        <div class="border-top pb-4"></div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div
                          v-if="userInfo.user_type === 'Operator'"
                          class="form-row form-group"
                        >
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >Ratio หน่วยซื้อ</label
                          >
                          <div class="col-lg-9 col-xl-9">
                            <div class="row">
                              <div class="col-4">
                                <input
                                  v-model="row.item.skuModel.unit.ratio"
                                  type="text"
                                  class="form-control text-right"
                                  disabled
                                />
                              </div>
                              <label class="col-4 col-form-label">
                                ขั้นตํ่าในการเปิด PO
                                <i
                                  class="ml-1 bx bx-info-circle align-middle absolute text-grey f-18"
                                  id="tooltip-factor-ratio"
                                />
                                <b-tooltip
                                  target="tooltip-factor-ratio"
                                  placement="right"
                                  variant="info"
                                  >หน่วยบรรจุ หรือ (Pack Size) (Container
                                  Factor)</b-tooltip
                                >
                              </label>
                              <div class="col-4">
                                <validationProvider
                                  v-slot="{ errors }"
                                  :name="
                                    `product_sku_quantity_container_factor`
                                  "
                                  :rules="{
                                    validateGreaterThanZero: true,
                                    dynamicRequired: ['กรุณาระบุข้อมูล'],
                                  }"
                                >
                                  <input
                                    :id="
                                      `product_sku_quantity_container_factor_${row.index}`
                                    "
                                    type="text"
                                    class="form-control text-right"
                                    v-model="
                                      row.item.skuModel.quantity
                                        .container_factor
                                    "
                                    @keydown="validateNum($event)"
                                    @input="
                                      row.item.skuModel.quantity.container_factor =
                                        row.item.skuModel.quantity
                                          .container_factor <= 0
                                          ? 1
                                          : row.item.skuModel.quantity
                                              .container_factor
                                    "
                                    :class="{
                                      'is-invalid': errors && errors.length,
                                    }"
                                    :disabled="
                                      dataPermissions.find(
                                        f => f.name === 'quantity'
                                      ).isEditable === false
                                    "
                                  />
                                  <span
                                    v-if="errors && errors.length"
                                    class="validate-invalid bt-22"
                                  >
                                    {{ errors[0] }}
                                  </span>
                                  <span class="validate-textbox"
                                    >หากไม่ทราบหน่วยบรรจุกรุณาระบุค่าไว้ที่ 1
                                  </span>
                                </validationProvider>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          v-else-if="
                            userInfo.user_type === 'Vendor' &&
                              vendor_type === 'OFMStock'
                          "
                          class="form-row form-group"
                        >
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >ขั้นตํ่าในการเปิด PO
                            <i
                              class="ml-1 bx bx-info-circle align-middle absolute text-grey f-18"
                              id="tooltip-factor-container_factor"
                            />
                            <b-tooltip
                              target="tooltip-factor-container_factor"
                              placement="right"
                              variant="info"
                              >หน่วยบรรจุ หรือ (Pack Size) (Container
                              Factor)</b-tooltip
                            >
                          </label>
                          <div class="col-lg-9 col-xl-9">
                            <div class="row">
                              <div class="col-4">
                                <validationProvider
                                  v-slot="{ errors }"
                                  :name="
                                    `product_sku_quantity_container_factor`
                                  "
                                  :rules="{
                                    validateGreaterThanZero: true,
                                    dynamicRequired: ['กรุณาระบุข้อมูล'],
                                  }"
                                >
                                  <input
                                    :id="
                                      `product_sku_quantity_container_factor_${row.index}`
                                    "
                                    type="text"
                                    class="form-control text-right"
                                    v-model="
                                      row.item.skuModel.quantity
                                        .container_factor
                                    "
                                    @keydown="validateNum($event)"
                                    @input="
                                      row.item.skuModel.quantity.container_factor =
                                        row.item.skuModel.quantity
                                          .container_factor <= 0
                                          ? 1
                                          : row.item.skuModel.quantity
                                              .container_factor
                                    "
                                    :class="{
                                      'is-invalid': errors && errors.length,
                                    }"
                                    :disabled="
                                      dataPermissions.find(
                                        f => f.name === 'quantity'
                                      ).isEditable === false
                                    "
                                  />
                                  <span
                                    v-if="errors && errors.length"
                                    class="validate-invalid bt-22"
                                  >
                                    {{ errors[0] }}
                                  </span>
                                </validationProvider>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div
                          v-if="
                            userInfo.user_type === 'Operator' ||
                              (userInfo.user_type === 'Vendor' &&
                                vendor_type === 'OFMStock')
                          "
                          class="form-row form-group"
                        >
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >ขั้นต่ำในการเปิด PO</label
                          >
                          <div class="col-lg-9 col-xl-9">
                            <div class="row">
                              <div class="col-4">
                                <validationProvider
                                  v-slot="{ errors }"
                                  :name="
                                    `product_sku_quantity_standard_pack_maximum`
                                  "
                                  :rules="{
                                    dynamicRequired: ['กรุณาระบุข้อมูล'],
                                  }"
                                >
                                  <input
                                    :id="
                                      `product_sku_quantity_standard_pack_maximum_${row.index}`
                                    "
                                    v-model="
                                      row.item.skuModel.quantity.standard_pack
                                        .maximum
                                    "
                                    @keydown="validateNum($event)"
                                    type="text"
                                    class="form-control text-right"
                                    :disabled="
                                      dataPermissions.find(
                                        f => f.name === 'quantity'
                                      ).isEditable === false
                                    "
                                    :class="{
                                      'is-invalid': errors && errors.length,
                                    }"
                                  />
                                  <span
                                    v-if="errors && errors.length"
                                    class="validate-invalid bt-22"
                                  >
                                    {{ errors[0] }}
                                  </span>
                                </validationProvider>
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <div
                          v-if="
                            userInfo.user_type === 'Operator' ||
                              (userInfo.user_type === 'Vendor' &&
                                vendor_type === 'DropShip')
                          "
                          class="form-row form-group"
                        >
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >จำนวนขั้นต่ำต่อ order ของลูกค้า</label
                          >
                          <div class="col-lg-9 col-xl-9">
                            <div class="row">
                              <div class="col-4">
                                <validationProvider
                                  v-slot="{ errors }"
                                  :name="
                                    `product_sku_quantity_limit_order_minimum`
                                  "
                                  :rules="{
                                    dynamicRequired: ['กรุณาระบุข้อมูล'],
                                  }"
                                >
                                  <input
                                    :id="
                                      `product_sku_quantity_limit_order_minimum_${row.index}`
                                    "
                                    v-model="
                                      row.item.skuModel.quantity.limit_order
                                        .minimum
                                    "
                                    @keydown="validateNum($event)"
                                    type="text"
                                    class="form-control text-right"
                                    :disabled="
                                      dataPermissions.find(
                                        f => f.name === 'quantity'
                                      ).isEditable === false
                                    "
                                    :class="{
                                      'is-invalid': errors && errors.length,
                                    }"
                                  />
                                  <small class="form-text text-muted"
                                    >หากไม่กำหนดกรุณาระบุค่าเป็น 0</small
                                  >
                                  <span
                                    v-if="errors && errors.length"
                                    class="validate-invalid bt-22"
                                  >
                                    {{ errors[0] }}
                                  </span>
                                </validationProvider>
                              </div>
                              <label class="col-4 col-form-label"
                                >จำนวนสูงสุดต่อ order ของลูกค้า</label
                              >
                              <div class="col-4">
                                <validationProvider
                                  v-slot="{ errors }"
                                  :name="
                                    `product_sku_quantity_limit_order_maximum`
                                  "
                                  :rules="{
                                    dynamicRequired: ['กรุณาระบุข้อมูล'],
                                  }"
                                >
                                  <input
                                    :id="
                                      `product_sku_quantity_limit_order_maximum_${row.index}`
                                    "
                                    v-model="
                                      row.item.skuModel.quantity.limit_order
                                        .maximum
                                    "
                                    @keydown="validateNum($event)"
                                    type="text"
                                    class="form-control text-right"
                                    :disabled="
                                      dataPermissions.find(
                                        f => f.name === 'quantity'
                                      ).isEditable === false
                                    "
                                    :class="{
                                      'is-invalid': errors && errors.length,
                                    }"
                                  />
                                  <small class="form-text text-muted"
                                    >หากไม่กำหนดกรุณาระบุค่าเป็น 0</small
                                  >
                                  <span
                                    v-if="errors && errors.length"
                                    class="validate-invalid bt-22"
                                  >
                                    {{ errors[0] }}
                                  </span>
                                </validationProvider>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
            <!-- Status -->
            <!-- v-if="
                userInfo.user_type === 'Operator' ||
                (userInfo.user_type === 'Vendor' && vendor_type === 'OFMStock')
              " -->
            <div
              v-if="userInfo.user_type === 'Operator'"
              class="card"
              :ref="`componentForm_${row.index}_Status`"
            >
              <div class="card-body border">
                <h4
                  class="card-title card-collapse pointer"
                  @click="
                    collapseStates[row.index].Status = !collapseStates[
                      row.index
                    ].Status
                  "
                >
                  Status
                  <span class="icon-collapse">
                    <button class="btn-icon-collapse" type="button">
                      <template>
                        <i
                          v-if="collapseStates[row.index].Status"
                          class="dripicons-minus"
                        />
                        <i v-else class="dripicons-plus" />
                      </template>
                    </button>
                  </span>
                </h4>
                <b-collapse
                  id="collapse-sku"
                  v-model="collapseStates[row.index].Status"
                >
                  <div class="pt-3">
                    <div class="row">
                      <div class="col-12">
                        <div class="border-top pb-4"></div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="form-row form-group">
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >ประเภทสินค้า</label
                          >
                          <div class="col-sm-9 col-form-label">
                            <b-form-radio-group
                              v-model="
                                row.item.skuModel.other.is_special_product
                              "
                              @change="onChangeSpecialProduct($event, row.item)"
                              :disabled="
                                vendor_type == 'DropShip' ||
                                  is_free ||
                                  dataPermissions.find(
                                    f => f.name === 'product_status'
                                  ).isEditable === false
                              "
                            >
                              <b-form-radio :value="false" class="w-160-px"
                                >Normal Product</b-form-radio
                              >
                              <b-form-radio :value="true" class="w-160-px"
                                >Special Product</b-form-radio
                              >
                            </b-form-radio-group>
                          </div>
                        </div>
                        <!-- <div class="form-row form-group">
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >สถานะสินค้าของผู้ขาย</label
                          >
                          <div class="col-lg-9 col-xl-9">
                            <div class="row">
                              <div class="col-4">
                                <multiselect
                                  v-model="
                                    row.item.skuModel.product_status.vendor
                                  "
                                  :options="optionsProductStatusVendor"
                                  :show-labels="false"
                                  placeholder="เลือกสถานะ"
                                  :disabled="
                                    dataPermissions.find(
                                      f => f.name === 'product_status'
                                    ).isEditable === false
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <div
                          v-if="userInfo.user_type === 'Operator'"
                          class="form-row form-group"
                        >
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >สถานะสินค้า (OFM)</label
                          >
                          <div class="col-lg-9 col-xl-9">
                            <div class="row">
                              <div class="col-4">
                                <validationProvider
                                  v-slot="{ errors }"
                                  :name="`productsku_product_status_inventory`"
                                  :rules="{
                                    dynamicRequired: ['กรุณาเลือก'],
                                  }"
                                >
                                  <multiselect
                                    :id="
                                      `productsku_product_status_inventory_${row.index}`
                                    "
                                    v-model="
                                      row.item.skuModel.product_status.inventory
                                    "
                                    @input="
                                      onChangeProductStatusInventory(row.item,row.index)
                                    "
                                    :options="(isAllPreOrder || row.index == 0)  ?
                                      productStatusInventoryOptions.map(m => m.text) : 
                                      productStatusInventoryOptions.filter(w=>w.text != 'PreOrder').map(m => m.text)
                                    "
                                    :show-labels="false"
                                    placeholder="เลือกสถานะ"
                                    :disabled="
                                      is_free ||
                                        row.item.skuModel.other
                                          .is_special_product ||
                                        dataPermissions.find(
                                          f => f.name === 'product_status'
                                        ).isEditable === false
                                    "
                                    :class="{
                                      'is-invalid': errors && errors.length,
                                    }"
                                  />
                                  <div
                                    v-if="errors && errors.length"
                                    class="validate-invalid bt-22"
                                  >
                                    <span>{{ errors[0] }}</span>
                                  </div>
                                  <span class="validate-textbox">
                                    กรณีเปลื่ยนสถานะสินค้า channel
                                    จะถูกรีเซ็ตเป็นค่าเริ่มต้น
                                  </span>
                                </validationProvider>
                              </div>
                              <!-- <label class="col-4 col-form-label">
                                สถานะสินค้าสำหรับการขาย
                              </label>
                              <div class="col-4">
                                <multiselect
                                  v-model="
                                    row.item.skuModel.product_status.sale
                                  "
                                  :options="['Active', 'Inactive']"
                                  :show-labels="false"
                                  placeholder="เลือกสถานะ"
                                  disabled
                                />
                              </div> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
            <!-- Image -->
            <div class="card" :ref="`componentForm_${row.index}_Image`">
              <div class="card-body border">
                <h4
                  class="card-title card-collapse pointer"
                  @click="
                    collapseStates[row.index].Image = !collapseStates[row.index]
                      .Image
                  "
                >
                  Image
                  <span class="icon-collapse">
                    <button class="btn-icon-collapse" type="button">
                      <template>
                        <i
                          v-if="collapseStates[row.index].Image"
                          class="dripicons-minus"
                        />
                        <i v-else class="dripicons-plus" />
                      </template>
                    </button>
                  </span>
                </h4>
                <b-collapse
                  id="collapse-sku"
                  v-model="collapseStates[row.index].Image"
                >
                  <div class="pt-3">
                    <div class="row">
                      <div class="col-12">
                        <div class="border-top pb-4"></div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="form-row form-group">
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >รูปสินค้า</label
                          >
                          <div class="col-sm-9 col-form-label">
                            <switches
                              :disabled="
                                vendor_type == 'DropShip' ||
                                  dataPermissions.find(f => f.name === 'image')
                                    .isEditable === false
                              "
                              v-model="row.item.skuModel.other.has_image"
                              type-bold="true"
                              color="info"
                              class="switch-inner-label custom-switches switches-small switches-margin-top"
                              text-enabled="มี"
                              text-disabled="ไม่มี"
                            ></switches>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
            <!-- Seo -->
            <div
              v-if="userInfo.user_type === 'Operator'"
              class="card"
              :ref="`componentForm_${row.index}_Seo`"
            >
              <div class="card-body border">
                <h4
                  class="card-title card-collapse pointer"
                  @click="
                    collapseStates[row.index].Seo = !collapseStates[row.index]
                      .Seo
                  "
                >
                  Search Engine Optimization
                  <span class="icon-collapse">
                    <button class="btn-icon-collapse" type="button">
                      <template>
                        <i
                          v-if="collapseStates[row.index].Seo"
                          class="dripicons-minus"
                        />
                        <i v-else class="dripicons-plus" />
                      </template>
                    </button>
                  </span>
                </h4>
                <b-collapse
                  id="collapse-sku"
                  v-model="collapseStates[row.index].Seo"
                >
                  <div class="pt-3">
                    <div class="row">
                      <div class="col-12">
                        <div class="border-top pb-4"></div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="form-row form-group">
                          <div class="col-3 d-none d-sm-none d-md-block"></div>
                          <div
                            class="col-sm-9 col-form-label d-none d-sm-none d-md-block"
                          >
                            <div class="row">
                              <label
                                class="col-lg-6 col-xl-6 col-form-label text-center"
                                >ข้อมูลภาษาไทย
                              </label>
                              <label
                                class="col-lg-6 col-xl-6 col-form-label text-center"
                                >ข้อมูลภาษาอังกฤษ
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="form-row form-group">
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >Title Tag</label
                          >
                          <div class="col-sm-9">
                            <div class="row">
                              <div class="col-sm-6">
                                <textarea
                                  v-model="row.item.skuModel.meta.title_tag.th"
                                  rows="4"
                                  type="text"
                                  class="form-control"
                                  :readonly="
                                    row.item.skuModel.meta.is_default[0] ||
                                      dataPermissions.find(
                                        f => f.name === 'meta'
                                      ).isEditable === false
                                  "
                                />
                                <b-form-checkbox
                                  class="mt-2 f-12"
                                  v-model="row.item.skuModel.meta.is_default[0]"
                                  @change="
                                    onClickCheckboxMeta(
                                      $event,
                                      row.item,
                                      'title_tag',
                                      'th'
                                    )
                                  "
                                  :disabled="
                                    dataPermissions.find(f => f.name === 'meta')
                                      .isEditable === false
                                  "
                                  >Use Default Value
                                </b-form-checkbox>
                              </div>
                              <div class="col-sm-6">
                                <textarea
                                  v-model="row.item.skuModel.meta.title_tag.en"
                                  rows="4"
                                  type="text"
                                  class="form-control"
                                  :readonly="
                                    row.item.skuModel.meta.is_default[1] ||
                                      dataPermissions.find(
                                        f => f.name === 'meta'
                                      ).isEditable === false
                                  "
                                />
                                <b-form-checkbox
                                  class="mt-2 f-12"
                                  v-model="row.item.skuModel.meta.is_default[1]"
                                  @change="
                                    onClickCheckboxMeta(
                                      $event,
                                      row.item,
                                      'title_tag',
                                      'en'
                                    )
                                  "
                                  :disabled="
                                    dataPermissions.find(f => f.name === 'meta')
                                      .isEditable === false
                                  "
                                  >Use Default Value</b-form-checkbox
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-row form-group">
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >Description Tag</label
                          >
                          <div class="col-sm-9">
                            <div class="row">
                              <div class="col-sm-6">
                                <textarea
                                  v-model="
                                    row.item.skuModel.meta.description_tag.th
                                  "
                                  rows="4"
                                  type="text"
                                  class="form-control"
                                  :readonly="
                                    row.item.skuModel.meta.is_default[2] ||
                                      dataPermissions.find(
                                        f => f.name === 'meta'
                                      ).isEditable === false
                                  "
                                />
                                <b-form-checkbox
                                  class="mt-2 f-12"
                                  v-model="row.item.skuModel.meta.is_default[2]"
                                  @change="
                                    onClickCheckboxMeta(
                                      $event,
                                      row.item,
                                      'description_tag',
                                      'th'
                                    )
                                  "
                                  :disabled="
                                    dataPermissions.find(f => f.name === 'meta')
                                      .isEditable === false
                                  "
                                  >Use Default Value</b-form-checkbox
                                >
                              </div>
                              <div class="col-sm-6">
                                <textarea
                                  v-model="
                                    row.item.skuModel.meta.description_tag.en
                                  "
                                  rows="4"
                                  type="text"
                                  class="form-control"
                                  :readonly="
                                    row.item.skuModel.meta.is_default[3] ||
                                      dataPermissions.find(
                                        f => f.name === 'meta'
                                      ).isEditable === false
                                  "
                                />
                                <b-form-checkbox
                                  class="mt-2 f-12"
                                  v-model="row.item.skuModel.meta.is_default[3]"
                                  @change="
                                    onClickCheckboxMeta(
                                      $event,
                                      row.item,
                                      'description_tag',
                                      'en'
                                    )
                                  "
                                  :disabled="
                                    dataPermissions.find(f => f.name === 'meta')
                                      .isEditable === false
                                  "
                                  >Use Default Value</b-form-checkbox
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-row form-group">
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >Keyword</label
                          >
                          <div class="col-sm-9">
                            <div class="row">
                              <div class="col-sm-6">
                                <div role="group" class="input-group">
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      TH
                                    </div>
                                  </div>
                                  <input
                                    v-model="row.item.skuModel.meta.keyword.th"
                                    type="text"
                                    class="form-control"
                                    :disabled="
                                      dataPermissions.find(
                                        f => f.name === 'meta'
                                      ).isEditable === false
                                    "
                                  />
                                </div>
                              </div>
                              <div class="col-sm-6">
                                <div role="group" class="input-group">
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      EN
                                    </div>
                                  </div>
                                  <input
                                    v-model="row.item.skuModel.meta.keyword.en"
                                    type="text"
                                    class="form-control"
                                    :disabled="
                                      dataPermissions.find(
                                        f => f.name === 'meta'
                                      ).isEditable === false
                                    "
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-row form-group">
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >Canonical Tag</label
                          >
                          <div class="col-sm-9">
                            <div class="row">
                              <div class="col-sm-6">
                                <div role="group" class="input-group">
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">TH</div>
                                  </div>
                                  <input
                                    v-model="
                                      row.item.skuModel.meta.cononical_tag.th
                                    "
                                    type="text"
                                    class="form-control"
                                    :disabled="
                                      dataPermissions.find(
                                        f => f.name === 'meta'
                                      ).isEditable === false
                                    "
                                  />
                                </div>
                              </div>
                              <div class="col-sm-6">
                                <div role="group" class="input-group">
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">EN</div>
                                  </div>
                                  <input
                                    v-model="
                                      row.item.skuModel.meta.cononical_tag.en
                                    "
                                    type="text"
                                    class="form-control"
                                    :disabled="
                                      dataPermissions.find(
                                        f => f.name === 'meta'
                                      ).isEditable === false
                                    "
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-row form-group">
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >Robot</label
                          >
                          <div class="col-sm-9">
                            <div class="row">
                              <div class="col-sm-6">
                                <div role="group" class="input-group">
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">TH</div>
                                  </div>
                                  <input
                                    v-model="row.item.skuModel.meta.robot.th"
                                    type="text"
                                    class="form-control"
                                    :disabled="
                                      dataPermissions.find(
                                        f => f.name === 'meta'
                                      ).isEditable === false
                                    "
                                  />
                                </div>
                              </div>
                              <div class="col-sm-6">
                                <div role="group" class="input-group">
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">EN</div>
                                  </div>
                                  <input
                                    v-model="row.item.skuModel.meta.robot.en"
                                    type="text"
                                    class="form-control"
                                    :disabled="
                                      dataPermissions.find(
                                        f => f.name === 'meta'
                                      ).isEditable === false
                                    "
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-row form-group">
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >Sitemap Priority</label
                          >
                          <div class="col-sm-9">
                            <div class="row">
                              <div class="col-sm-6">
                                <validationProvider
                                  v-slot="{ errors }"
                                  :name="`productsku_sitemap_priority_th`"
                                  :rules="{
                                    dynamicRequired: [
                                      'กรุณาระบุข้อมูลเป็นตัวเลข',
                                    ],
                                  }"
                                >
                                  <div role="group" class="input-group">
                                    <div class="input-group-prepend">
                                      <div class="input-group-text">TH</div>
                                    </div>
                                    <input
                                      :id="
                                        `productsku_sitemap_priority_th_${row.index}`
                                      "
                                      v-model="
                                        row.item.skuModel.meta.sitemap_priority
                                          .th
                                      "
                                      v-bind:min="0"
                                      v-bind:max="99.9"
                                      @input="
                                        row.item.skuModel.meta.sitemap_priority.th = validateDecimalWithModel(
                                          row.item.skuModel.meta
                                            .sitemap_priority.th,
                                          1,
                                          100
                                        )
                                      "
                                      :class="{
                                        'is-invalid': errors && errors.length,
                                      }"
                                      type="text"
                                      class="form-control text-right"
                                      :disabled="
                                        dataPermissions.find(
                                          f => f.name === 'meta'
                                        ).isEditable === false
                                      "
                                    />
                                    <div
                                      v-if="errors && errors.length"
                                      class="validate-invalid bt-22"
                                    >
                                      <span>{{ errors[0] }}</span>
                                    </div>
                                  </div>
                                </validationProvider>
                              </div>
                              <div class="col-sm-6">
                                <validationProvider
                                  v-slot="{ errors }"
                                  :name="`productsku_sitemap_priority_en`"
                                  :rules="{
                                    dynamicRequired: [
                                      'กรุณาระบุข้อมูลเป็นตัวเลข',
                                    ],
                                  }"
                                >
                                  <div role="group" class="input-group">
                                    <div class="input-group-prepend">
                                      <div class="input-group-text">EN</div>
                                    </div>
                                    <input
                                      :id="
                                        `productsku_sitemap_priority_en_${row.index}`
                                      "
                                      v-model="
                                        row.item.skuModel.meta.sitemap_priority
                                          .en
                                      "
                                      v-bind:min="0"
                                      v-bind:max="99.9"
                                      @input="
                                        row.item.skuModel.meta.sitemap_priority.en = validateDecimalWithModel(
                                          row.item.skuModel.meta
                                            .sitemap_priority.en,
                                          1,
                                          100
                                        )
                                      "
                                      type="text"
                                      :class="{
                                        'is-invalid': errors && errors.length,
                                      }"
                                      class="form-control text-right"
                                      :disabled="
                                        dataPermissions.find(
                                          f => f.name === 'meta'
                                        ).isEditable === false
                                      "
                                    />
                                    <div
                                      v-if="errors && errors.length"
                                      class="validate-invalid bt-22"
                                    >
                                      <span>{{ errors[0] }}</span>
                                    </div>
                                  </div>
                                </validationProvider>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-row form-group">
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >SEO URL</label
                          >
                          <div class="col-sm-9">
                            <div class="row">
                              <div class="col-sm-12">
                                <div role="group" class="input-group">
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">TH</div>
                                  </div>
                                  <input
                                    v-model="row.item.skuModel.meta.seo_name.th"
                                    type="text"
                                    class="form-control"
                                    :readonly="true"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-row form-group">
                          <label
                            class="col-lg-3 col-xl-3 col-form-label"
                          ></label>
                          <div class="col-sm-9">
                            <div class="row">
                              <div class="col-sm-12">
                                <div role="group" class="input-group">
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">EN</div>
                                  </div>
                                  <input
                                    v-model="row.item.skuModel.meta.seo_name.en"
                                    type="text"
                                    class="form-control"
                                    :readonly="true"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
            <!-- Inventory Information -->
            <div
              v-if="userInfo.user_type === 'Operator'"
              class="card"
              :ref="`componentForm_${row.index}_InventoryInformation`"
            >
              <div class="card-body border">
                <h4
                  class="card-title card-collapse pointer"
                  @click="
                    collapseStates[
                      row.index
                    ].InventoryInformation = !collapseStates[row.index]
                      .InventoryInformation
                  "
                >
                  Inventory Information
                  <span class="icon-collapse">
                    <button class="btn-icon-collapse" type="button">
                      <template>
                        <i
                          v-if="collapseStates[row.index].InventoryInformation"
                          class="dripicons-minus"
                        />
                        <i v-else class="dripicons-plus" />
                      </template>
                    </button>
                  </span>
                </h4>
                <b-collapse
                  id="collapse-sku"
                  v-model="collapseStates[row.index].InventoryInformation"
                >
                  <div class="pt-3">
                    <div class="row">
                      <div class="col-12">
                        <div class="border-top pb-4"></div>
                      </div>
                    </div>
                    <div class="row" v-if="row.item.skuModel.product_names">
                      <div class="col-12">
                        <div
                          class="form-row form-group"
                          v-if="
                            row.item.skuModel.product_names.some(
                              f => f.type == 'Inventory'
                            )
                          "
                        >
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >ชื่อสินค้า (สำหรับคลังสินค้า)
                            <i
                              class="ml-1 bx bx-info-circle align-middle absolute text-grey f-18"
                              id="product_name_inven"
                            />
                            <b-tooltip
                              target="product_name_inven"
                              placement="right"
                              variant="info"
                            >
                              Format [th] ชื่อสินค้าตั้งต้น เว้นวรรค ขนาด
                              เว้นวรรค สี เว้นวรรค หน่วยขาย เว้นวรรค แบรนด์
                              เว้นวรรค รุ่น
                              <p />
                              Format [en] แบรนด์ เว้นวรรค ชื่อสินค้าตั้งต้น
                              เว้นวรรค รุ่น เว้นวรรค ขนาด เว้นวรรค สี เว้นวรรค
                              หน่วยขาย
                            </b-tooltip>
                          </label>
                          <div class="col-sm-9">
                            <validationProvider
                              v-slot="{ errors }"
                              :name="`productsku_product_names_inventory_th`"
                              :rules="{
                                validateSingleQuote: true,
                              }"
                            >
                              <div
                                role="group"
                                class="input-group check-length"
                              >
                                <div class="input-group-prepend">
                                  <div class="input-group-text">TH</div>
                                </div>
                                <input
                                  :id="
                                    `productsku_product_names_inventory_th_${row.index}`
                                  "
                                  v-model="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Inventory'
                                    ).display_name.th
                                  "
                                  type="text"
                                  class="form-control"
                                  maxlength="200"
                                  :class="{
                                    'is-invalid': errors && errors.length,
                                  }"
                                  :disabled="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Inventory'
                                    ).isDefault ||
                                      dataPermissions.find(
                                        f => f.name === 'product_names'
                                      ).isEditable === false
                                  "
                                />
                                <span
                                  v-if="
                                    row.item.skuModel.product_names.some(
                                      f => f.type == 'Inventory'
                                    )
                                  "
                                  class="badge input-validate-length"
                                  :class="{
                                    'badge-success':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'Inventory'
                                      ).display_name.th.length !== 200,
                                    'badge-danger':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'Inventory'
                                      ).display_name.th.length === 200,
                                  }"
                                  >{{
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Inventory'
                                    ).display_name.th.length
                                  }}/200</span
                                >
                                <div
                                  v-if="errors && errors.length"
                                  class="validate-invalid bt-22"
                                >
                                  <span>{{ errors[0] }}</span>
                                </div>
                              </div>
                            </validationProvider>
                          </div>
                        </div>
                        <div
                          class="form-row form-group"
                          v-if="
                            row.item.skuModel.product_names.some(
                              f => f.type == 'Inventory'
                            )
                          "
                        >
                          <label
                            class="col-lg-3 col-xl-3 col-form-label"
                          ></label>
                          <div class="col-sm-9">
                            <validationProvider
                              v-slot="{ errors }"
                              :name="`productsku_product_names_inventory_en`"
                              :rules="{
                                validateSingleQuote: true,
                              }"
                            >
                              <div
                                role="group"
                                class="input-group check-length"
                              >
                                <div class="input-group-prepend">
                                  <div class="input-group-text">EN</div>
                                </div>
                                <input
                                  :id="
                                    `productsku_product_names_inventory_en_${row.index}`
                                  "
                                  v-model="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Inventory'
                                    ).display_name.en
                                  "
                                  type="text"
                                  class="form-control"
                                  maxlength="200"
                                  :class="{
                                    'is-invalid': errors && errors.length,
                                  }"
                                  :disabled="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Inventory'
                                    ).isDefault ||
                                      dataPermissions.find(
                                        f => f.name === 'product_names'
                                      ).isEditable === false
                                  "
                                />
                                <span
                                  v-if="
                                    row.item.skuModel.product_names.some(
                                      f => f.type == 'Inventory'
                                    )
                                  "
                                  class="badge input-validate-length"
                                  :class="{
                                    'badge-success':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'Inventory'
                                      ).display_name.en.length !== 200,
                                    'badge-danger':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'Inventory'
                                      ).display_name.en.length === 200,
                                  }"
                                  >{{
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Inventory'
                                    ).display_name.en.length
                                  }}/200</span
                                >
                                <div
                                  v-if="errors && errors.length"
                                  class="validate-invalid bt-22"
                                >
                                  <span>{{ errors[0] }}</span>
                                </div>
                              </div>
                            </validationProvider>
                            <b-form-checkbox
                              class="mt-2 f-12"
                              v-model="
                                row.item.skuModel.product_names.find(
                                  f => f.type == 'Inventory'
                                ).isDefault
                              "
                              @change="
                                onChangeDefault($event, row.item, 'Inventory')
                              "
                              :disabled="
                                dataPermissions.find(
                                  f => f.name === 'product_names'
                                ).isEditable === false
                              "
                              >Default Product Name</b-form-checkbox
                            >
                          </div>
                        </div>
                        <div
                          class="form-row form-group"
                          v-if="
                            row.item.skuModel.product_names.some(
                              f => f.type == 'Handheld'
                            )
                          "
                        >
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >ชื่อสินค้า (สำหรับอุปกรณ์ Handheld)
                            <i
                              class="ml-1 bx bx-info-circle align-middle absolute text-grey f-18"
                              id="product_name_hand"
                            />
                            <b-tooltip
                              target="product_name_hand"
                              placement="right"
                              variant="info"
                            >
                              Format [th] ชื่อสินค้าตั้งต้น เว้นวรรค แบรนด์
                              เว้นวรรค รุ่น เว้นวรรค สี เว้นวรรค ขนาด
                              <p />
                              Format [en] แบรนด์ เว้นวรรค ชื่อสินค้าตั้งต้น
                              เว้นวรรค รุ่น เว้นวรรค ขนาด เว้นวรรค สี
                            </b-tooltip>
                          </label>
                          <div class="col-sm-9">
                            <validationProvider
                              v-slot="{ errors }"
                              :name="`productsku_product_names_handheld_th`"
                              :rules="{
                                validateSingleQuote: true,
                              }"
                            >
                              <div
                                role="group"
                                class="input-group check-length"
                              >
                                <div class="input-group-prepend">
                                  <div class="input-group-text">TH</div>
                                </div>
                                <input
                                  :id="
                                    `productsku_product_names_handheld_th_${row.index}`
                                  "
                                  v-model="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Handheld'
                                    ).display_name.th
                                  "
                                  type="text"
                                  class="form-control"
                                  maxlength="20"
                                  :class="{
                                    'is-invalid': errors && errors.length,
                                  }"
                                  :disabled="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Handheld'
                                    ).isDefault ||
                                      dataPermissions.find(
                                        f => f.name === 'product_names'
                                      ).isEditable === false
                                  "
                                />
                                <span
                                  v-if="
                                    row.item.skuModel.product_names.some(
                                      f => f.type == 'Handheld'
                                    )
                                  "
                                  class="badge input-validate-length"
                                  :class="{
                                    'badge-success':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'Handheld'
                                      ).display_name.th.length !== 20,
                                    'badge-danger':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'Handheld'
                                      ).display_name.th.length === 20,
                                  }"
                                  >{{
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Handheld'
                                    ).display_name.th.length
                                  }}/20</span
                                >
                                <div
                                  v-if="errors && errors.length"
                                  class="validate-invalid bt-22"
                                >
                                  <span>{{ errors[0] }}</span>
                                </div>
                              </div>
                            </validationProvider>
                          </div>
                        </div>
                        <div
                          class="form-row form-group"
                          v-if="
                            row.item.skuModel.product_names.some(
                              f => f.type == 'Handheld'
                            )
                          "
                        >
                          <label
                            class="col-lg-3 col-xl-3 col-form-label"
                          ></label>
                          <div class="col-sm-9">
                            <validationProvider
                              v-slot="{ errors }"
                              :name="`productsku_product_names_handheld_en`"
                              :rules="{
                                validateSingleQuote: true,
                              }"
                            >
                              <div
                                role="group"
                                class="input-group check-length"
                              >
                                <div class="input-group-prepend">
                                  <div class="input-group-text">EN</div>
                                </div>
                                <input
                                  :id="
                                    `productsku_product_names_handheld_en_${row.index}`
                                  "
                                  v-model="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Handheld'
                                    ).display_name.en
                                  "
                                  type="text"
                                  class="form-control"
                                  maxlength="20"
                                  :class="{
                                    'is-invalid': errors && errors.length,
                                  }"
                                  :disabled="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Handheld'
                                    ).isDefault ||
                                      dataPermissions.find(
                                        f => f.name === 'product_names'
                                      ).isEditable === false
                                  "
                                />
                                <span
                                  v-if="
                                    row.item.skuModel.product_names.some(
                                      f => f.type == 'Handheld'
                                    )
                                  "
                                  class="badge input-validate-length"
                                  :class="{
                                    'badge-success':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'Handheld'
                                      ).display_name.en.length !== 20,
                                    'badge-danger':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'Handheld'
                                      ).display_name.en.length === 20,
                                  }"
                                  >{{
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'Handheld'
                                    ).display_name.en.length
                                  }}/20</span
                                >
                                <div
                                  v-if="errors && errors.length"
                                  class="validate-invalid bt-22"
                                >
                                  <span>{{ errors[0] }}</span>
                                </div>
                              </div>
                            </validationProvider>
                            <b-form-checkbox
                              class="mt-2 f-12"
                              v-model="
                                row.item.skuModel.product_names.find(
                                  f => f.type == 'Handheld'
                                ).isDefault
                              "
                              @change="
                                onChangeDefault($event, row.item, 'Handheld')
                              "
                              :disabled="
                                dataPermissions.find(
                                  f => f.name === 'product_names'
                                ).isEditable === false
                              "
                              >Default Product Name</b-form-checkbox
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
            <!-- JDA Information -->
            <div
              v-if="userInfo.user_type === 'Operator'"
              class="card"
              :ref="`componentForm_${row.index}_JDAInformation`"
            >
              <div class="card-body border">
                <h4
                  class="card-title card-collapse pointer"
                  @click="
                    collapseStates[row.index].JDAInformation = !collapseStates[
                      row.index
                    ].JDAInformation
                  "
                >
                  JDA Information
                  <span class="icon-collapse">
                    <button class="btn-icon-collapse" type="button">
                      <template>
                        <i
                          v-if="collapseStates[row.index].JDAInformation"
                          class="dripicons-minus"
                        />
                        <i v-else class="dripicons-plus" />
                      </template>
                    </button>
                  </span>
                </h4>
                <b-collapse
                  id="collapse-sku"
                  v-model="collapseStates[row.index].JDAInformation"
                >
                  <div class="pt-3">
                    <div class="row">
                      <div class="col-12">
                        <div class="border-top pb-4"></div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="form-row form-group">
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >ชื่อสินค้า (สำหรับระบบ JDA)
                            <i
                              class="ml-1 bx bx-info-circle align-middle absolute text-grey f-18"
                              id="product_name_jda"
                            />
                            <b-tooltip
                              target="product_name_jda"
                              placement="right"
                              variant="info"
                            >
                              Format [th] ชื่อสินค้าตั้งต้น เว้นวรรค แบรนด์
                              เว้นวรรค รุ่น เว้นวรรค สี เว้นวรรค ขนาด
                              <p />
                              Format [en] แบรนด์ เว้นวรรค ชื่อสินค้าตั้งต้น
                              เว้นวรรค รุ่น เว้นวรรค ขนาด เว้นวรรค สี
                            </b-tooltip>
                          </label>
                          <div class="col-sm-9">
                            <validationProvider
                              v-slot="{ errors }"
                              :name="`productsku_product_names_jda_th`"
                              :rules="{
                                validateSingleQuote: true,
                              }"
                            >
                              <div
                                role="group"
                                class="input-group check-length"
                              >
                                <div class="input-group-prepend">
                                  <div class="input-group-text">TH</div>
                                </div>
                                <input
                                  :id="
                                    `productsku_product_names_jda_th_${row.index}`
                                  "
                                  v-model="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'JDA'
                                    ).display_name.th
                                  "
                                  type="text"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': errors && errors.length,
                                  }"
                                  maxlength="30"
                                  :disabled="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'JDA'
                                    ).isDefault ||
                                      dataPermissions.find(
                                        f => f.name === 'product_names'
                                      ).isEditable === false
                                  "
                                />
                                <span
                                  v-if="
                                    row.item.skuModel.product_names.some(
                                      f => f.type == 'JDA'
                                    )
                                  "
                                  class="badge input-validate-length"
                                  :class="{
                                    'badge-success':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'JDA'
                                      ).display_name.th.length !== 30,
                                    'badge-danger':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'JDA'
                                      ).display_name.th.length === 30,
                                  }"
                                  >{{
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'JDA'
                                    ).display_name.th.length
                                  }}/30</span
                                >
                                <div
                                  v-if="errors && errors.length"
                                  class="validate-invalid bt-22"
                                >
                                  <span>{{ errors[0] }}</span>
                                </div>
                              </div>
                            </validationProvider>
                          </div>
                        </div>
                        <div class="form-row form-group">
                          <label
                            class="col-lg-3 col-xl-3 col-form-label"
                          ></label>
                          <div class="col-sm-9">
                            <validationProvider
                              v-slot="{ errors }"
                              :name="`productsku_product_names_jda_en`"
                              :rules="{
                                validateSingleQuote: true,
                              }"
                            >
                              <div
                                role="group"
                                class="input-group check-length"
                              >
                                <div class="input-group-prepend">
                                  <div class="input-group-text">EN</div>
                                </div>
                                <input
                                  :id="
                                    `productsku_product_names_jda_en_${row.index}`
                                  "
                                  v-model="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'JDA'
                                    ).display_name.en
                                  "
                                  type="text"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': errors && errors.length,
                                  }"
                                  maxlength="30"
                                  :disabled="
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'JDA'
                                    ).isDefault ||
                                      dataPermissions.find(
                                        f => f.name === 'product_names'
                                      ).isEditable === false
                                  "
                                />
                                <span
                                  v-if="
                                    row.item.skuModel.product_names.some(
                                      f => f.type == 'JDA'
                                    )
                                  "
                                  class="badge input-validate-length"
                                  :class="{
                                    'badge-success':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'JDA'
                                      ).display_name.en.length !== 30,
                                    'badge-danger':
                                      row.item.skuModel.product_names.find(
                                        f => f.type == 'JDA'
                                      ).display_name.en.length === 30,
                                  }"
                                  >{{
                                    row.item.skuModel.product_names.find(
                                      f => f.type == 'JDA'
                                    ).display_name.en.length
                                  }}/30</span
                                >
                                <div
                                  v-if="errors && errors.length"
                                  class="validate-invalid bt-22"
                                >
                                  <span>{{ errors[0] }}</span>
                                </div>
                              </div>
                            </validationProvider>
                            <b-form-checkbox
                              class="mt-2 f-12"
                              v-model="
                                row.item.skuModel.product_names.find(
                                  f => f.type == 'JDA'
                                ).isDefault
                              "
                              :disabled="
                                dataPermissions.find(
                                  f => f.name === 'product_names'
                                ).isEditable === false
                              "
                              @change="onChangeDefault($event, row.item, 'JDA')"
                              >Default Product Name</b-form-checkbox
                            >
                          </div>
                        </div>
                        <div class="form-row form-group">
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >สถานะสินค้า (JDA)</label
                          >
                          <div class="col-sm-9">
                            <div class="row">
                              <div class="col-sm-4 col-form-label">
                                <b-form-radio-group
                                  v-model="row.item.skuModel.jda.status"
                                  :disabled="
                                    row.item.skuModel.other
                                      .is_special_product ||
                                      dataPermissions.find(
                                        f => f.name === 'jda'
                                      ).isEditable === false
                                  "
                                >
                                  <b-form-radio value="A" class="w-90-px"
                                    >A</b-form-radio
                                  >
                                  <b-form-radio value="I" class="w-90-px"
                                    >I</b-form-radio
                                  >
                                </b-form-radio-group>
                              </div>
                              <div
                                class="col-sm-4"
                                v-if="row.item.skuModel.jda.status == 'I'"
                              >
                                <validationProvider
                                  v-slot="{ errors }"
                                  :name="`productsku_jda_special_type`"
                                  :rules="{
                                    dynamicRequired: ['กรุณาเลือก'],
                                  }"
                                >
                                  <multiselect
                                    :id="
                                      `productsku_jda_special_type_${row.index}`
                                    "
                                    v-model="row.item.skuModel.jda.special_type"
                                    :options="
                                      options_special_type.map(s => s.value)
                                    "
                                    :show-labels="false"
                                    placeholder="เลือกสถานะ"
                                    :class="{
                                      'is-invalid': errors && errors.length,
                                    }"
                                    :disabled="
                                      dataPermissions.find(
                                        f => f.name === 'jda'
                                      ).isEditable === false
                                    "
                                  />
                                  <span
                                    v-if="errors && errors.length"
                                    class="validate-invalid bt-22"
                                  >
                                    {{ errors[0] }}
                                  </span>
                                  <span
                                    v-else-if="
                                      row.item.skuModel.jda.special_type
                                    "
                                    class="validate-textbox"
                                    >{{
                                      options_special_type.find(
                                        s =>
                                          s.value ==
                                          row.item.skuModel.jda.special_type
                                      )
                                        ? options_special_type.find(
                                            s =>
                                              s.value ==
                                              row.item.skuModel.jda.special_type
                                          ).message
                                        : ''
                                    }}
                                  </span>
                                </validationProvider>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
            <!-- Substitute -->
            <div
              v-if="userInfo.user_type === 'Operator'"
              class="card"
              :ref="`componentForm_${row.index}_Substitute`"
            >
              <div class="card-body border">
                <h4
                  class="card-title card-collapse pointer"
                  @click="
                    collapseStates[row.index].Substitute = !collapseStates[
                      row.index
                    ].Substitute
                  "
                >
                  Substitute
                  <i
                    class="
                                ml-1
                                bx bx-info-circle
                                align-middle
                                absolute
                                text-grey
                                f-18
                              "
                    id="tooltip-factor-substitutes"
                  />
                  <b-tooltip
                    target="tooltip-factor-substitutes"
                    placement="right"
                    variant="info"
                    >สินค้าเก่าที่ถูกทดแทน</b-tooltip
                  >
                  <span class="icon-collapse">
                    <button class="btn-icon-collapse" type="button">
                      <template>
                        <i
                          v-if="collapseStates[row.index].Substitute"
                          class="dripicons-minus"
                        />
                        <i v-else class="dripicons-plus" />
                      </template>
                    </button>
                  </span>
                </h4>
                <b-collapse
                  id="collapse-sku-substitute"
                  v-model="collapseStates[row.index].Substitute"
                >
                  <div class="pt-3">
                    <div class="row">
                      <div class="col-12">
                        <div class="border-top pb-4"></div>
                      </div>
                    </div>
                    <!-- <div class="row">
                      <label class="col-lg-3 col-xl-3 col-form-label">
                        สินค้าเก่าที่ถูกทดแทน
                      </label>
                    </div> -->
                    <div class="row">
                      <div class="col-12">
                        <div
                          class="form-row form-group"
                          v-if="
                            dataPermissions.find(f => f.name === 'substitutes')
                              .isEditable === true
                          "
                        >
                          <label class="col-lg-3 col-xl-3 col-form-label">
                            รหัสสินค้า (OFM) ที่ทดแทน
                          </label>
                          <div class="col-sm-2">
                            <form @submit.prevent="getProductSkuAsync(row)">
                              <input
                                v-model="
                                  row.item.skuModel.substitute_input.sku_id
                                "
                                type="text"
                                class="form-control"
                                maxlength="20"
                                @input="
                                  row.item.skuModel.substitute_input.sku_id = $event.target.value.toUpperCase()
                                "
                              />
                            </form>
                          </div>
                          <div class="col-sm-2">
                            <span v-if="isLoadingGetProductSku">
                              <b-spinner
                                small
                                label="Small Spinner"
                              ></b-spinner>
                              กำลังโหลดข้อมูล...
                            </span>
                          </div>
                          <div class="col-lg-5 text-sm-right">
                            <div class="button-items">
                              <button
                                type="button"
                                class="btn btn-primary btn-sm waves-effect mt-1"
                                @click="getProductSkuAsync(row)"
                              >
                                <i
                                  class="bx bx-search font-size-16 align-middle mr-2"
                                ></i>
                                Search
                              </button>
                              <button
                                type="button"
                                class="btn btn-light btn-sm waves-effect mt-1"
                                @click="
                                  onConfirmClearSkuInfomationSubstitute(row)
                                "
                              >
                                <i
                                  class="bx bx-reset font-size-16 align-middle mr-2"
                                ></i>
                                Clear
                              </button>
                            </div>
                          </div>
                        </div>
                        <div
                          class="form-row form-group"
                          v-if="
                            dataPermissions.find(f => f.name === 'substitutes')
                              .isEditable === true
                          "
                        >
                          <label class="col-lg-3 col-xl-3 col-form-label">
                            รหัสกลุ่มสินค้า
                          </label>
                          <div class="col-sm-2">
                            <input
                              v-model="
                                row.item.skuModel.substitute_input.product_id
                              "
                              type="text"
                              class="form-control"
                              maxlength="20"
                              disabled
                            />
                          </div>
                        </div>
                        <div
                          class="form-row form-group"
                          v-if="
                            dataPermissions.find(f => f.name === 'substitutes')
                              .isEditable === true
                          "
                        >
                          <label class="col-lg-3 col-xl-3 col-form-label">
                            ชื่อสินค้า
                          </label>
                          <div class="col-sm-9 text-left">
                            <input
                              v-bind:value="
                                row.item.skuModel.substitute_input.product_name
                                  .en &&
                                row.item.skuModel.substitute_input.product_name
                                  .en !== ''
                                  ? `${row.item.skuModel.substitute_input.product_name.th} | ${row.item.skuModel.substitute_input.product_name.en}`
                                  : ''
                              "
                              type="text"
                              class="form-control"
                              disabled
                            />
                          </div>
                        </div>
                        <div
                          class="form-row form-group"
                          v-if="
                            dataPermissions.find(f => f.name === 'substitutes')
                              .isEditable === true
                          "
                        >
                          <label class="col-lg-3 col-xl-3 col-form-label"
                            >สถานะสินค้า</label
                          >
                          <div class="col">
                            <div class="row">
                              <div class="col-4">
                                <input
                                  v-model="
                                    row.item.skuModel.substitute_input
                                      .product_status.inventory
                                  "
                                  type="text"
                                  class="form-control"
                                  disabled
                                />
                              </div>
                              <label class="col-4 col-form-label"
                                >สถานะการขาย</label
                              >
                              <div class="col-4">
                                <input
                                  v-model="
                                    row.item.skuModel.substitute_input
                                      .product_status.sale
                                  "
                                  type="text"
                                  class="form-control"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="form-row form-group"
                          v-if="
                            dataPermissions.find(f => f.name === 'substitutes')
                              .isEditable === true
                          "
                        >
                          <div class="col-3 d-none d-sm-none d-md-block"></div>
                          <div class="col">
                            <button
                              type="button"
                              @click="onAddSubstitute(row)"
                              class="btn btn-success btn-sm"
                              :disabled="
                                dataPermissions.find(
                                  f => f.name === 'substitutes'
                                ).isEditable === false
                              "
                            >
                              <i class="bx bx-plus" />
                              Add
                            </button>
                          </div>
                        </div>
                        <div class="form-row form-group">
                          <div class="col">
                            <b-table
                              id="table-product-detail-substitute"
                              class="line-height striped"
                              :empty-text="'ไม่พบข้อมูล'"
                              :show-empty="
                                !row.item.skuModel ||
                                  !row.item.skuModel.substitutes_to.length ||
                                  row.item.skuModel.substitutes_to.length == 0
                              "
                              :bordered="true"
                              v-bind:items="row.item.skuModel.substitutes_to"
                              v-bind:fields="substituteFields"
                            >
                              <template v-slot:cell(index)="data">
                                <div>
                                  {{ (data.index + 1) | number }}
                                </div>
                              </template>

                              <template v-slot:cell(product_name)="data">
                                <span v-if="data.value && data.value.th">{{
                                  data.value.th + ' : ' + data.value.en
                                }}</span>
                              </template>
                              <template
                                v-slot:cell(product_status_inventory)="data"
                              >
                                <span
                                  v-if="
                                    data.item.product_status &&
                                      data.item.product_status.inventory
                                  "
                                  class="label"
                                  :class="
                                    'label-' +
                                      data.item.product_status.inventory.toLowerCase()
                                  "
                                  v-html="data.item.product_status.inventory"
                                ></span>
                              </template>
                              <template v-slot:cell(product_status_sale)="data">
                                <span
                                  v-if="
                                    data.item.product_status &&
                                      data.item.product_status.sale
                                  "
                                  class="label"
                                  :class="
                                    'label-' +
                                      data.item.product_status.sale.toLowerCase()
                                  "
                                  v-html="data.item.product_status.sale"
                                ></span>
                              </template>
                              <template v-slot:cell(action)="data">
                                <div
                                  class="text-center"
                                  v-if="
                                    dataPermissions.find(
                                      f => f.name === 'substitutes'
                                    ).isEditable === true
                                  "
                                >
                                  <a
                                    @click="onDeleteSubstitute(row, data.index)"
                                    class="btn btn-ico text-danger"
                                    ><i class="bx bx-trash"></i
                                  ></a>
                                </div>
                              </template>
                            </b-table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <button
                  v-if="dataPermissions.some(s => s.isEditable === true)"
                  type="button"
                  @click="onUpdate(row.item, row.index)"
                  class="btn btn-primary btn-sm"
                >
                  <i class="bx bx-save" />
                  Update
                </button>
                <button
                  type="button"
                  class="btn btn-light btn-sm"
                  @click="closeRows(row.item, row.index)"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </validationObserver>
    </template>
  </b-table>
</template>
<script>
//Helpers
import { FormatQty } from '@/helpers/utils/format-qty.js'
import validate from '@/helpers/utils/validate.js'
import productService from '@/helpers/service/product-service'
import { getUserInfo } from '@/helpers/utils/jwt'
import {
  navProductDetailComputed,
  navProductDetailMethods,
} from '@/state/helpers'

//Vue Component Install
import Multiselect from 'vue-multiselect'
import Switches from 'vue-switches'
import PercentageCircle from 'vue-css-percentage-circle'

//Components
import InputFormatDecimal from '@/components/share/input-decimal-format.vue'
import { authComputed } from '@/state/helpers'
import { eventBus } from '@/main.js'

export default {
  name: 'TableProductDetail',
  components: { Multiselect, Switches, PercentageCircle, InputFormatDecimal },
  mixins: [validate],
  props: {
    value: {
      type: Array,
      default: () => {
        return this.items
      },
    },
    generatesku: {
      type: Array,
      default: () => {
        return []
      },
    },
    basicModel: {
      type: Object,
    },
    vendor_type: {
      type: String,
      default: () => {
        return ''
      },
    },
    discount_rate_1: {
      type: Number,
      default: () => {
        return 0.0
      },
    },
    is_free: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    is_view: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    requestDocumentInformation: {
      type: Object,
      default: () => {
        return null
      },
    },
    vat_rate: {
      type: Number,
      default: () => {
        return 0
      },
    },
    business_unit : {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      collapseStates: [],
      items: [],
      fields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: '#',
          thClass: 'w-50-px',
          tdClass: 'text-center',
          sortable: false,
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width: 200px',
          tdClass: 'text-center',
          sortable: false,
        },
      ],
      options_fix_price_period: [
        { value: 'NO', text: 'ไม่ยืนราคา' },
        { value: '3M', text: '3 เดือน' },
        { value: '6M', text: '6 เดือน' },
        { value: '12M', text: '12 เดือน' },
      ],
      options_special_type: [
        {
          value: 'C',
          message:
            'สินค้า InCat OFM เก็บ Stock ที่คลังสินค้า แต่ไม่ได้เก็บ Stock ขายที่สาขา',
        },
        {
          value: 'S',
          message:
            'สินค้าสั่งพิเศษเฉพาะที่มีลูกค้ามาติดต่อขอสั่งเท่านั้น ไม่เก็บ Stock',
        },
        {
          value: 'M',
          message: 'สินค้า Initial Order เติม Stock โดยจัดซื้อ',
        },
        {
          value: 'O',
          message: 'สินค้าขาด Stock ชั่วคราวจาก Vendor',
        },
        {
          value: 'R',
          message:
            'สินค้าเลิกขายจากการตัดสินใจของฝ่ายจัดซื้อ สาขาทำคืน (RTV) ได้ทันที',
        },
      ],
      optionsProductStatusVendor: [
        'Stock',
        'Out Of Stock',
        'EOL (End of Life)',
      ],
      optionsOfmStockInventoryStatus: [
        {
          text: 'New',
          product_status_sale: 'Inactive',
          is_available_stock: false,
        },
        {
          text: 'Stock',
          product_status_sale: 'Active',
          is_available_stock: true,
        },
        {
          text: 'Limited',
          product_status_sale: 'Active',
          is_available_stock: true,
        },
        {
          text: 'Clearance',
          product_status_sale: 'Active',
          is_available_stock: true,
        },
        {
          text: 'OutOfStock',
          product_status_sale: 'Active',
          is_available_stock: true,
        },
        // #103208 ปรับกลุ่มสินค้าสถานะ Control, ByOrder, Special หากมีจำนวนขายได้ในระบบ ให้สร้างเป็น SO , is_available_stock: true,
        {
          text: 'Control',
          product_status_sale: 'Active',
          is_available_stock: true,
        },
        {
          text: 'ByOrder',
          product_status_sale: 'Active',
          is_available_stock: true,
        },
        {
          text: 'Special',
          product_status_sale: 'Active',
          is_available_stock: true,
        },
        {
          text: 'NonStock',
          product_status_sale: 'Active',
          is_available_stock: false,
        },
        {
          text: 'PreOrder',
          product_status_sale: 'Active',
          is_available_stock: false,
        },
        {
          text: 'Hold',
          product_status_sale: 'Inactive',
          is_available_stock: false,
        },
        {
          text: 'InStore',
          product_status_sale: 'Inactive',
          is_available_stock: false,
        },
        {
          text: 'Internal',
          product_status_sale: 'Inactive',
          is_available_stock: false,
        },
        {
          text: 'Free',
          product_status_sale: 'Active',
          is_available_stock: true,
        },
      ],
      optionsVendorDropShipInventoryStatus: [
        {
          text: 'NonStock',
          product_status_sale: 'Active',
          is_available_stock: true,
        },
        {
          text: 'Hold',
          product_status_sale: 'Inactive',
          is_available_stock: false,
        },
      ],
      optionsOfmStockFreeInventoryStatus: [
        {
          text: 'Free',
          product_status_sale: 'Active',
          is_available_stock: true,
        },
      ],
      substituteFields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thClass: 'w-50-px',
          tdClass: 'text-center',
          sortable: false,
        },
        {
          key: 'product_id',
          label: 'รหัสกลุ่มสินค้า',
          sortable: false,
          tdClass: 'text-center',
        },
        {
          key: 'sku_id',
          label: 'รหัสสินค้า (OFM)',
          tdClass: 'text-center',
          sortable: false,
        },
        {
          key: 'product_name',
          label: 'ชื่อสินค้า',
          sortable: false,
        },
        {
          key: 'product_status_inventory',
          label: 'สถานะสินค้า',
          tdClass: 'text-center',
          sortable: false,
        },
        {
          key: 'product_status_sale',
          label: 'สถานะการขาย',
          tdClass: 'text-center',
          sortable: false,
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width: 100px',
          tdClass: 'text-center',
          sortable: false,
        },
      ],
      permissions: [
        {
          name: 'skus',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
        {
          name: 'sku_codes',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
        {
          name: 'sku_codes_jda',
          ruleIDs: ['P8'],
          isEditable: false,
        },
        {
          name: 'barcodes',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
        {
          name: 'mechanics',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
        {
          name: 'product_names',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
        {
          name: 'product_names_online',
          ruleIDs: ['P1', 'P5'],
          isEditable: false,
        },
        {
          name: 'prices',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
        {
          name: 'quantity',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
        {
          name: 'product_status',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
        {
          name: 'image',
          ruleIDs: ['P1', 'P4'],
          isEditable: false,
        },
        {
          name: 'jda',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
        {
          name: 'meta',
          ruleIDs: ['P1', 'P5'],
          isEditable: false,
        },
        {
          name: 'substitutes',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
      ],
      isFirstWatchValue: true,
      option_sku_mechanic_default: [],
      refIndex: 0,
      refActiveDetail: '',
      isFirstLoaded: false,
      isAllPreOrder : true,
      isLoadingGetProductSku: false,
    }
  },
  computed: {
    ...authComputed,
    ...navProductDetailComputed,
    userInfo() {
      if (this.getAccessToken !== null) {
        return getUserInfo(this.getAccessToken)
      } else return {}
    },
    dataPermissions() {
      let permissions = this.permissions
      if (
        this.requestDocumentInformation !== null &&
        this.requestDocumentInformation !== undefined &&
        this.requestDocumentInformation.approval_documents !== null &&
        this.requestDocumentInformation.approval_documents !== undefined
      ) {
        let ruleEditables = this.requestDocumentInformation.approval_documents
          .filter(f => f.my_process_action.can_edit === true)
          .map(m => m.rule_id)

        permissions
          .filter(f => f.ruleIDs.some(s => ruleEditables.some(r => r === s)))
          .forEach(element => {
            element.isEditable = true
          })
      } else {
        permissions.forEach(element => {
          element.isEditable = this.is_view ? false : true
        })
      }
      console.log('vendor ',this.vendor_type)
      return permissions
    },
    is_best_deal() {
      return this.basicModel && this.basicModel.is_best_deal
        ? true
        : this.vendor_type === 'DropShip'
        ? true
        : false
    },
    productStatusInventoryOptions() {
      let options = []
      if (this.vendor_type === 'DropShip') {
        options = this.optionsVendorDropShipInventoryStatus
      } else if (this.is_free === true) {
        options = this.optionsOfmStockFreeInventoryStatus
      } else {
        options = this.optionsOfmStockInventoryStatus.filter(
          f => f.text !== 'Free' && f.text !== 'Special'
        )
      }
      return options
    },
  },
  watch: {
    refActiveDetail: {
      handler(val) {
        eventBus.$emit('ref_active_detail', { index: this.refIndex, ref: val })
      },
    },
    value: {
      handler(val) {
        // console.log('Watch value', val)
        if (
          val[0] &&
          val[0].skuModel.mechanics.length > 0 &&
          this.items.length == 0
        ) {
          this.fields = [
            {
              key: 'index',
              formatter: (value, key, item) => {
                return FormatQty(value ? value : 0)
              },
              label: '#',
              thClass: 'w-50-px',
              tdClass: 'text-center',
              sortable: false,
            },
            {
              key: 'action',
              label: 'Action',
              thStyle: 'width: 200px',
              tdClass: 'text-center',
              sortable: false,
            },
            {
              key: 'successRate',
              label: '',
              thStyle: 'width: 50px',
              tdClass: 'text-center',
              sortable: false,
            },
          ]

          val[0].skuModel.mechanics.forEach((element, index) => {
            this.fields.splice(index + 1, 0, {
              key: `mechanic_${index + 1}`,
              label: element.display_name.th,
              tdClass: 'text-center',
              sortable: false,
            })
          })

          let isFinished =
            this.requestDocumentInformation == null
              ? false
              : this.requestDocumentInformation.approval_documents.some(
                  s =>
                    (s.rule_id === 'P6' &&
                      s.my_process_action.can_edit === true) ||
                    (s.rule_id === 'P7' &&
                      s.my_process_action.can_edit === true) ||
                    (s.rule_id === 'P8' &&
                      s.my_process_action.can_edit === true)
                ) ||
                this.dataPermissions.find(f => f.name === 'skus').isEditable ===
                  false

          this.items = val.map((element, index) => {
            let isValidated = false
            if (
              this.userInfo.user_type === 'Vendor' &&
              this.vendor_type === 'OFMStock'
            ) {
              if (
                ((element.skuModel.prices.some(f => f.type == 'Cost') &&
                  element.skuModel.prices.find(f => f.type == 'Cost')
                    .exclude_vat !== null &&
                  element.skuModel.prices.find(f => f.type == 'Cost')
                    .exclude_vat !== '' &&
                  element.skuModel.prices.find(f => f.type == 'Cost')
                    .exclude_vat > 0) ||
                  this.is_free) &&
                ((element.skuModel.prices.some(f => f.type == 'RetailPrice') &&
                  element.skuModel.prices.find(f => f.type == 'RetailPrice')
                    .include_vat !== null &&
                  element.skuModel.prices.find(f => f.type == 'RetailPrice')
                    .include_vat !== '' &&
                  element.skuModel.prices.find(f => f.type == 'RetailPrice')
                    .include_vat > 0) ||
                  this.is_free)
              ) {
                isValidated = true
              }
            } else if (
              this.userInfo.user_type === 'Vendor' &&
              this.vendor_type === 'DropShip'
            ) {
              if (
                (((element.skuModel.prices.some(f => f.type == 'RetailPrice') &&
                  element.skuModel.prices.find(f => f.type == 'RetailPrice')
                    .include_vat !== null &&
                  element.skuModel.prices.find(f => f.type == 'RetailPrice')
                    .include_vat !== '' &&
                  element.skuModel.prices.find(f => f.type == 'RetailPrice')
                    .include_vat > 0) ||
                  this.is_free) &&
                  element.skuModel.prices.some(f => f.type == 'SalePrice') &&
                  element.skuModel.prices.find(f => f.type == 'SalePrice')
                    .include_vat !== null &&
                  element.skuModel.prices.find(f => f.type == 'SalePrice')
                    .include_vat !== '' &&
                  element.skuModel.prices.find(f => f.type == 'SalePrice')
                    .include_vat > 0) ||
                this.is_free
              ) {
                isValidated = true
              }
            } else if (this.userInfo.user_type === 'Operator') {
              if (
                (((element.skuModel.other.fix_price_period !== '' &&
                  element.skuModel.other.fix_price_period !== null) ||
                  this.is_free) &&
                  element.skuModel.product_status.inventory !== '' &&
                  element.skuModel.product_status.inventory !== null &&
                  element.skuModel.product_status.sale !== '' &&
                  element.skuModel.product_status.sale !== null &&
                  element.skuModel.quantity.container_factor !== null &&
                  element.skuModel.quantity.container_factor !== '' &&
                  element.skuModel.quantity.container_factor > 0 &&
                  ((element.skuModel.prices.some(f => f.type == 'Cost') &&
                    element.skuModel.prices.find(f => f.type == 'Cost')
                      .exclude_vat !== null &&
                    element.skuModel.prices.find(f => f.type == 'Cost')
                      .exclude_vat !== '' &&
                    element.skuModel.prices.find(f => f.type == 'Cost')
                      .exclude_vat > 0) ||
                    this.is_free) &&
                  ((element.skuModel.prices.some(
                    f => f.type == 'RetailPrice'
                  ) &&
                    element.skuModel.prices.find(f => f.type == 'RetailPrice')
                      .include_vat !== null &&
                    element.skuModel.prices.find(f => f.type == 'RetailPrice')
                      .include_vat !== '' &&
                    element.skuModel.prices.find(f => f.type == 'RetailPrice')
                      .include_vat > 0) ||
                    this.is_free) &&
                  element.skuModel.prices.some(f => f.type == 'SalePrice') &&
                  element.skuModel.prices.find(f => f.type == 'SalePrice')
                    .include_vat !== null &&
                  element.skuModel.prices.find(f => f.type == 'SalePrice')
                    .include_vat !== '' &&
                  element.skuModel.prices.find(f => f.type == 'SalePrice')
                    .include_vat > 0) ||
                this.is_free
              ) {
                if (
                  element.skuModel.jda.status === 'I' &&
                  element.skuModel.jda.special_type === ''
                ) {
                  isValidated = false
                } else {
                  isValidated = true
                }
              }
            }

            return {
              index: index + 1,
              validateState: isFinished || isValidated,
              successRate:
                element.successRate !== '' && element.successRate !== undefined
                  ? element.successRate
                  : isFinished || isValidated
                  ? 100
                  : 86,
              skuModel: element.skuModel,
              _showDetails: false,
            }
          })

          this.collapseStates = []
          // this.checkVendorTypeDropShip(this.vendor_type)
          this.items.forEach(element => {
            // this.onChangeDefault(true, element, 'All')
            this.onCalculatePrice(element)
            if (element.skuModel.meta && element.skuModel.meta.title_tag) {
              if (element.skuModel.meta.title_tag.th === '') {
                this.onClickCheckboxMeta(true, element, 'title_tag', 'th')
                element.skuModel.meta.is_default[0] = true
              }
              if (element.skuModel.meta.title_tag.en === '') {
                this.onClickCheckboxMeta(true, element, 'title_tag', 'en')
                element.skuModel.meta.is_default[1] = true
              }
              if (element.skuModel.meta.description_tag.th === '') {
                this.onClickCheckboxMeta(true, element, 'description_tag', 'th')
                element.skuModel.meta.is_default[2] = true
              }
              if (element.skuModel.meta.description_tag.en === '') {
                this.onClickCheckboxMeta(true, element, 'description_tag', 'en')
                element.skuModel.meta.is_default[3] = true
              }
            }

            this.collapseStates.push({
              SKUCode: true,
              SKUInformation: true,
              ProductName: true,
              Price: true,
              Quantity: true,
              Status: true,
              Image: true,
              Seo: true,
              InventoryInformation: true,
              JDAInformation: true,
              Substitute: true,
            })
          })

          this.SET_NAV_PRODUCT_DETAIL({
            items: this.items,
            pageName: 'productRegister',
          })

          this.$nextTick(() => {
            this.modelChanged()
          })
        }
      },
      deep: true,
    },
    generatesku: {
      handler: function(val) {
        // console.log('generatesku', val)
        if (val && val.length > 0) {
          this.fields = [
            {
              key: 'index',
              formatter: (value, key, item) => {
                return FormatQty(value ? value : 0)
              },
              label: '#',
              thClass: 'w-50-px',
              tdClass: 'text-center',
              sortable: false,
            },
            {
              key: 'action',
              label: 'Action',
              thStyle: 'width: 200px',
              tdClass: 'text-center',
              sortable: false,
            },
            {
              key: 'successRate',
              label: '',
              thStyle: 'width: 50px',
              tdClass: 'text-center',
              sortable: false,
            },
          ]

          val.forEach((element, index) => {
            this.fields.splice(index + 1, 0, {
              key: `mechanic_${index + 1}`,
              label: element.display_name.th,
              tdClass: 'text-center',
              sortable: false,
            })
          })

          this.getItems(val)
        } else {
          this.items = []
          this.fields = []
        }
      },
      // deep: true,
    },
    'basicModel.oracle_code': {
      handler: function(val) {
        this.items.forEach(element => {
          if (element) {
            element.skuModel.sku_codes.find(f => f.type == 'CPC').code = val
          }
        })
      },
      deep: true,
    },
    'basicModel.commission_rate': {
      handler: function(val) {
        console.log('B',val)
        this.items.forEach((element, index) => {
          if (element) {
            // ไม่กำหนดค่า commission_rate เมื่ออยู่หน้า products_register_request
            const path_name = this.$route.name
            if (path_name !== 'products_register_request') {
              element.skuModel.other.commission_rate = val
            } else {
              // console.log('isFirstLoaded', this.isFirstLoaded)
              if (this.isFirstLoaded === true) {
                element.skuModel.other.commission_rate = val
              }
            }
            this.onCalculatePrice(element)
          }
          if (this.items.length === index + 1) this.isFirstLoaded = true
        })
      },      
      deep: true,
    },
    'basicModel.gp_standard': {
      handler: function(val) {
        this.items.forEach(element => {
          element.skuModel.gross_profit.gp_standard = val
        })
      },
      deep: true,
    },
    'basicModel.product_names': {
      handler: function(val) {
        this.items.forEach(element => {
          if (element) {
            if (
              element.skuModel.product_names.find(f => f.type == 'Document')
                .isDefault
            ) {
              this.onChangeDefault(true, element, 'Document')
            }
            if (
              element.skuModel.product_names.find(f => f.type == 'Online')
                .isDefault
            ) {
              this.onChangeDefault(true, element, 'Online')
            }
          }
        })
      },
      deep: true,
    },
    is_best_deal: {
      handler: function(val) {
        if (val) {
          this.items.forEach(element => {
            element.skuModel.other.is_best_deal = val
          })
        }
      },
      deep: true,
    },
    vendor_type: {
      handler: function(val) {
        this.checkVendorTypeDropShip(val)
      },
      deep: true,
    },
    discount_rate_1: {
      handler: function(val) {
        this.items.forEach(element => {
          this.onCalculatePrice(element)
        })
      },
      deep: true,
    },
    is_free: {
      handler: function(val) {
        if (val === true) {
          this.items.forEach(element => {
            element.skuModel.product_status.inventory = 'Free'
            element.skuModel.product_status.sale = 'Active'
            element.skuModel.other.is_available_stock = true
            element.skuModel.other.is_free = true
          })
        } else {
          this.items.forEach(element => {
            element.skuModel.other.is_free = false
          })
        }
      },
      deep: true,
    },
  },
  mounted() {
    // this.$nextTick(() => {
    // })
  },
  created() {
    eventBus.$on(
      'nav-product-detail-set-collapse-state',
      ({ item, collapseState }) => {
        // console.log('item', item)
        // console.log(this.items[item.index - 1]._showDetails)
        this.items[item.index - 1]._showDetails = collapseState
        this.SET_NAV_PRODUCT_DETAIL_COLLAPSE_STATE({
          index: item.index,
          collapseState,
        })
        this.$nextTick(() => {
          this.scrollToRef(item.ref)
          this.refIndex = item.index - 1
        })
      }
    )
    eventBus.$on(
      'sub-nav-product-detail-set-collapse-state',
      ({ item, collapseState }) => {
        this.SET_SUB_NAV_PRODUCT_DETAIL_COLLAPSE_STATE({
          index: item.index,
          id: item.id,
          collapseState,
        })
        this.$nextTick(() => {
          this.scrollToRef(item.ref)
        })
      }
    )
  },
  beforeMount() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...navProductDetailMethods,
    modelChanged() {
      this.$emit('input', this.items)
    },
    reCheckValidation() {
      let vm = this
      this.items.forEach(function(value, i) {
        // vm.reloadPercent(value,i)
        vm.onUpdate(value, i, false)
      })
    },
    getItems(val) {
      // console.log('getItems')
      let skuItems = []
      let index = 0

      if (val.length == 1) {
        val[0].values.forEach(h1 => {
          let mechanics = [
            {
              id: val[0].id,
              display_name: {
                th: val[0].display_name.th,
                en: val[0].display_name.en,
              },
              type: val[0].type,
              collection: val[0].collection,
              value: {
                id: h1.id,
                display_name: {
                  th: h1.display_name.th,
                  en: h1.display_name.en,
                },
                color_code: '',
                images: [
                  {
                    size: '',
                    url: '',
                  },
                ],
              },
            },
          ]

          skuItems.push(this.mappingData(++index, mechanics))
        })
      } else if (val.length == 2) {
        val[0].values.forEach(h1 => {
          val[1].values.forEach(h2 => {
            let mechanics = [
              {
                id: val[0].id,
                display_name: {
                  th: val[0].display_name.th,
                  en: val[0].display_name.en,
                },
                type: val[0].type,
                collection: val[0].collection,
                value: {
                  id: h1.id,
                  display_name: {
                    th: h1.display_name.th,
                    en: h1.display_name.en,
                  },
                  color_code: '',
                  images: [
                    {
                      size: '',
                      url: '',
                    },
                  ],
                },
              },
              {
                id: val[1].id,
                display_name: {
                  th: val[1].display_name.th,
                  en: val[1].display_name.en,
                },
                type: val[1].type,
                collection: val[1].collection,
                value: {
                  id: h2.id,
                  display_name: {
                    th: h2.display_name.th,
                    en: h2.display_name.en,
                  },
                  color_code: '',
                  images: [
                    {
                      size: '',
                      url: '',
                    },
                  ],
                },
              },
            ]

            skuItems.push(this.mappingData(++index, mechanics))
          })
        })
      } else if (val.length == 3) {
        val[0].values.forEach(h1 => {
          val[1].values.forEach(h2 => {
            val[2].values.forEach(h3 => {
              let mechanics = [
                {
                  id: val[0].id,
                  display_name: {
                    th: val[0].display_name.th,
                    en: val[0].display_name.en,
                  },
                  type: val[0].type,
                  collection: val[0].collection,
                  value: {
                    id: h1.id,
                    display_name: {
                      th: h1.display_name.th,
                      en: h1.display_name.en,
                    },
                    color_code: '',
                    images: [
                      {
                        size: '',
                        url: '',
                      },
                    ],
                  },
                },
                {
                  id: val[1].id,
                  display_name: {
                    th: val[1].display_name.th,
                    en: val[1].display_name.en,
                  },
                  type: val[1].type,
                  collection: val[1].collection,
                  value: {
                    id: h2.id,
                    display_name: {
                      th: h2.display_name.th,
                      en: h2.display_name.en,
                    },
                    color_code: '',
                    images: [
                      {
                        size: '',
                        url: '',
                      },
                    ],
                  },
                },
                {
                  id: val[2].id,
                  display_name: {
                    th: val[2].display_name.th,
                    en: val[2].display_name.en,
                  },
                  type: val[2].type,
                  collection: val[2].collection,
                  value: {
                    id: h3.id,
                    display_name: {
                      th: h3.display_name.th,
                      en: h3.display_name.en,
                    },
                    color_code: '',
                    images: [
                      {
                        size: '',
                        url: '',
                      },
                    ],
                  },
                },
              ]

              skuItems.push(this.mappingData(++index, mechanics))
            })
          })
        })
      } else if (val.length == 4) {
        val[0].values.forEach(h1 => {
          val[1].values.forEach(h2 => {
            val[2].values.forEach(h3 => {
              val[3].values.forEach(h4 => {
                let mechanics = [
                  {
                    id: val[0].id,
                    display_name: {
                      th: val[0].display_name.th,
                      en: val[0].display_name.en,
                    },
                    type: val[0].type,
                    collection: val[0].collection,
                    value: {
                      id: h1.id,
                      display_name: {
                        th: h1.display_name.th,
                        en: h1.display_name.en,
                      },
                      color_code: '',
                      images: [
                        {
                          size: '',
                          url: '',
                        },
                      ],
                    },
                  },
                  {
                    id: val[1].id,
                    display_name: {
                      th: val[1].display_name.th,
                      en: val[1].display_name.en,
                    },
                    type: val[1].type,
                    collection: val[1].collection,
                    value: {
                      id: h2.id,
                      display_name: {
                        th: { th: h2.display_name.th, en: h2.display_name.en }
                          .th,
                        en: { th: h2.display_name.th, en: h2.display_name.en }
                          .en,
                      },
                      color_code: '',
                      images: [
                        {
                          size: '',
                          url: '',
                        },
                      ],
                    },
                  },
                  {
                    id: val[2].id,
                    display_name: {
                      th: val[2].display_name.th,
                      en: val[2].display_name.en,
                    },
                    type: val[2].type,
                    collection: val[2].collection,
                    value: {
                      id: h3.id,
                      display_name: {
                        th: h3.display_name.th,
                        en: h3.display_name.en,
                      },
                      color_code: '',
                      images: [
                        {
                          size: '',
                          url: '',
                        },
                      ],
                    },
                  },
                  {
                    id: val[3].id,
                    display_name: {
                      th: val[3].display_name.th,
                      en: val[3].display_name.en,
                    },
                    type: val[3].type,
                    collection: val[3].collection,
                    value: {
                      id: h4.id,
                      display_name: {
                        th: h4.display_name.th,
                        en: h4.display_name.en,
                      },
                      color_code: '',
                      images: [
                        {
                          size: '',
                          url: '',
                        },
                      ],
                    },
                  },
                ]

                skuItems.push(this.mappingData(++index, mechanics))
              })
            })
          })
        })
      }
      skuItems = skuItems.map(it => ({ ...it, _showDetails: false }))
      this.items = skuItems
      this.collapseStates = []
      // this.checkVendorTypeDropShip(this.vendor_type)
      this.items.forEach(element => {
        this.onChangeDefault(true, element, 'All')
        this.onClickCheckboxMeta(true, element, 'title_tag', 'th')
        this.onClickCheckboxMeta(true, element, 'title_tag', 'en')
        this.onClickCheckboxMeta(true, element, 'description_tag', 'th')
        this.onClickCheckboxMeta(true, element, 'description_tag', 'en')
        this.collapseStates.push({
          SKUCode: true,
          SKUInformation: true,
          ProductName: true,
          Price: true,
          Quantity: true,
          Status: true,
          Image: true,
          Seo: true,
          InventoryInformation: true,
          JDAInformation: true,
          Substitute: true,
        })
      })

      this.modelChanged()
      eventBus.$emit('onSetDefault', {type:'Status',value:''})
    },
    async onSuccessRate(item, index) {
      //Update SEO Name by Product Name Type Online
      this.getProductSEONameAsync(
        item.skuModel.product_names.find(f => f.type == 'Online').display_name,
        item
      )

      if (
        this.dataPermissions.find(f => f.name === 'skus').isEditable === false
      ) {
        this.items[index].validateState = true
        this.items[index].successRate = 100
        this.modelChanged()
        return
      }

      //--------- คำนวณ % เสร็จสิ้นของ SKU Row--------------------------
      let objError = this.$refs[`componentForm_${index}`].errors
      let totalValidate = Object.keys(objError).length
      let totalError = 0
      let errorList = []
      Object.keys(objError).forEach(element => {
        if (objError[element].length > 0) {
          ++totalError
          errorList.push(element)
        }
      })
      let successRate = Math.ceil(100 - (totalError / totalValidate) * 100)
      this.items[index].successRate = successRate
      //--------------------------------------------------------------

      this.items[index].validateState = false
    },
    onDelete(index) {
      this.items.splice(index, 1)
      this.modelChanged()
      this.$nextTick(() => {
        this.SET_NAV_PRODUCT_DETAIL({
          items: this.items,
          pageName: 'productRegister',
        })
      })
    },
    onDeleteSubstitute(row, index) {
      row.item.skuModel.substitutes_to.splice(index, 1)
      row.item.skuModel.substitutes_to.forEach((element, index) => {
        element.sequence = index + 1
      })
    },
    onAddSubstitute(row) {
      //ตอนได้ product ID และ SKU ID ต้องเอามา Update ให้
      row.item.skuModel.substitutes_to.push({
        sequence: row.item.skuModel.substitutes_to.length + 1,
        product_id: row.item.skuModel.substitute_input.product_id,
        sku_id: row.item.skuModel.substitute_input.sku_id,
        product_name: row.item.skuModel.substitute_input.product_name,
        product_status: row.item.skuModel.substitute_input.product_status,
      })
      //----
      // หาจุดที่ใช้ Substitute (ตัดออก) เนื่องการตอนนี้จะใช้แค่ substitute_to
      // row.item.skuModel.substitutes = [
      //   {
      //     sequence: 1,
      //     product_id: row.item.skuModel.product_id,
      //     sku_id: row.item.skuModel.sku_code_ofm,
      //     product_name: row.item.skuModel.product_names.find(
      //       f => f.type == 'Online'
      //     ).display_name,
      //     product_status: Object.assign(
      //       {},
      //       {
      //         vendor: '',
      //         inventory: '',
      //         sale: '',
      //       }
      //     ),
      //   },
      // ]

      this.onClearSkuInfomationSubstitute(row)
    },
    async getProductSkuAsync(row) {
      this.isLoadingGetProductSku = true
      if (
        row.item.skuModel.substitute_input.sku_id &&
        row.item.skuModel.substitute_input.sku_id !== '' &&
        row.item.skuModel.substitutes_to.some(
          s => s.sku_id == row.item.skuModel.substitute_input.sku_id
        )
      ) {
        this.$utils.notification(
          'error',
          `ไม่สามารถเพิ่มข้อมูลของสินค้า ${row.item.skuModel.substitute_input.sku_id} ได้ เนื่องจากสินค้าถูกเพิ่มลงใน Substitute แล้ว`,
          2000
        )
      } else if (
        row.item.skuModel.substitute_input.sku_id &&
        row.item.skuModel.substitute_input.sku_id !== ''
      ) {
        let params = new URLSearchParams()
        params.append('pageNo', 1)
        params.append('pageSize', 9999)
        params.append('sort', 'product_id')
        params.append('keyword', row.item.skuModel.substitute_input.sku_id)
        let result = await productService.getProductSkuListAsync(params)
        if (result.status === 200) {
          if (result.data.items.length > 0) {
            row.item.skuModel.substitute_input = {
              sku_id: result.data.items[0].id,
              product_id: result.data.items[0].product_id,
              product_name: result.data.items[0].product_names.find(
                f => f.type == 'Online'
              ).display_name,
              product_status: Object.assign(
                {},
                {
                  vendor: result.data.items[0].product_status.vendor,
                  inventory: result.data.items[0].product_status.inventory,
                  sale:
                    result.data.items[0].product_status.sale &&
                    result.data.items[0].product_status.sale !== ''
                      ? result.data.items[0].product_status.sale
                      : this.optionsOfmStockInventoryStatus.find(
                          f =>
                            f.text ==
                            result.data.items[0].product_status.inventory
                        ).product_status_sale,
                }
              ),
            }
          } else {
            this.$utils.notification(
              'error',
              `ไม่พบข้อมูลของสินค้า ${row.item.skuModel.substitute_input.sku_id} ในระบบ`,
              2000
            )
          }
        } else if (result.status === 404) {
          this.$utils.notification(
            'error',
            `ไม่พบข้อมูลของสินค้า ${row.item.skuModel.substitute_input.sku_id} ในระบบ`,
            2000
          )
        }
      } else {
        this.$utils.notification('error', `กรุณากรอกข้อมูลเพื่อค้นหา`, 2000)
      }
      this.isLoadingGetProductSku = false
    },
    async onConfirmClearSkuInfomationSubstitute(row) {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการ Reset หน้าจอเป็นใช้ค่าเริ่มต้นใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            this.onClearSkuInfomationSubstitute(row)
          }
        })
    },
    onClearSkuInfomationSubstitute(row) {
      row.item.skuModel.substitute_input.sku_id = ''
      row.item.skuModel.substitute_input.product_id = ''
      row.item.skuModel.substitute_input.product_name = { en: '', th: '' }
      row.item.skuModel.substitute_input.product_status = Object.assign(
        {},
        {
          vendor: '',
          inventory: '',
          sale: '',
        }
      )
    },
    closeRows(item, index) {
      document.getElementById('row-product-' + index).scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
      setTimeout(() => {
        item._showDetails = false
      }, 500)
    },
    mappingData(index, mechanics) {
      let objData = {
        index: index,
        validateState: false,
        successRate: 0,
        skuModel: Object.assign(
          {},
          {
            id: '',
            sku_code_ofm: `${this.genHexString(24)}`,
            product_id: '',
            sku_codes: [
              {
                type: 'OFM',
                code: '',
              },
              {
                type: 'JDA',
                code: '',
              },
              {
                type: 'CPC',
                code: this.basicModel ? this.basicModel.oracle_code : '',
              },
              {
                type: 'Vendor',
                code: '',
              },
              {
                type: 'MarketPlace',
                code: '',
              },
              {
                type: 'B2S',
                code: '',
              },
            ],
            product_status: {
              vendor: '',
              inventory: this.is_free
                ? 'Free'
                : this.vendor_type === 'DropShip'
                ? 'NonStock'
                : '',
              sale: this.is_free
                ? 'Active'
                : this.vendor_type === 'DropShip'
                ? 'Active'
                : '',
            },
            barcodes: [
              {
                type: 'Vendor',
                barcode: '',
              },
              {
                type: 'OFM',
                barcode: '',
              },
            ],
            product_names: [
              {
                type: 'Document',
                display_name: {
                  th: '',
                  en: '',
                },
                isDefault: true,
              },
              {
                type: 'JDA',
                display_name: {
                  th: '',
                  en: '',
                },
                isDefault: true,
              },
              {
                type: 'Inventory',
                display_name: {
                  th: '',
                  en: '',
                },
                isDefault: true,
              },
              {
                type: 'Online',
                display_name: {
                  th: '',
                  en: '',
                },
                isDefault: true,
              },
              {
                type: 'Handheld',
                display_name: {
                  th: '',
                  en: '',
                },
                isDefault: true,
              },
            ],
            mechanics: mechanics,
            unit: {
              display_name: mechanics.find(f => f.collection == 'unit').value
                .display_name,
              ratio: 1,
            },
            quantity: {
              standard_pack: {
                minimum: 0,
                maximum: 0,
              },
              limit_order: {
                minimum: 0,
                maximum: 0,
              },
              container_factor: 1,
            },
            other: {
              is_consignment: false,
              has_new_product_fee: false,
              is_return_to_vendor: false,
              aging: 30,
              is_import: false,
              is_bidding_price: false,
              is_preorder: false,
              is_available_stock: this.is_free === true,
              is_free: this.is_free,
              is_default_barcode: true,
              is_best_deal: this.is_best_deal,
              is_vat: true,
              fix_price_period: 'NO',
              mr_point: 0,
              has_image: true,
              is_hamper: false,
              is_special_product: false,
              is_special_product_eprocurement: false,
              commission_rate: this.basicModel
                ? this.basicModel.commission_rate
                : 0.0,
              discount_rate: 0.0,
              has_component: false,
              product_remark: '',
              vendor_remark: '',
              is_delivery_restriction: false,
              commission_rate_type: 'Standard'
            },
            jda: {
              status: 'A',
              special_type: '',
            },
            meta: {
              is_default: [true, true, true, true],
              title_tag: {
                th: '',
                en: '',
              },
              description_tag: {
                th: '',
                en: '',
              },
              keyword: {
                th: '',
                en: '',
              },
              cononical_tag: {
                th: '',
                en: '',
              },
              robot: {
                th: '',
                en: '',
              },
              sitemap_priority: {
                th: 0.0,
                en: 0.0,
              },
              seo_name: {
                th: '',
                en: '',
              },
            },
            substitute_input: {
              sku_id: '',
              product_id: '',
              product_name: { en: '', th: '' },
              product_status: { vendor: '', inventory: '', sale: '' },
            },
            substitutes: [],
            substitutes_to: [],
            prices: [
              {
                type: 'OriginalCost',
                exclude_vat: 0.0,
                include_vat: 0.0,
              },
              {
                type: 'OriginalSalePrice',
                exclude_vat: 0,
                include_vat: 0.0,
              },
              {
                type: 'Cost',
                exclude_vat: 0.0,
                include_vat: 0.0,
              },
              {
                type: 'SalePrice',
                exclude_vat: 0.0,
                include_vat: 0.0,
              },
              {
                type: 'RetailPrice',
                exclude_vat: 0.0,
                include_vat: 0.0,
              },
            ],
            gross_profit: {
              gp_standard:
                this.basicModel &&
                this.basicModel.gp_standard &&
                this.basicModel.gp_standard > 0.0
                  ? this.basicModel.gp_standard
                  : 0.0,
              gp_rate: 0.0,
              gp_amount: 0.0,
              cost_of_sale: 0.0,
              isGPBelow5Percent: false,
            },
          }
        ),
      }
      return objData
    },
    checkVendorTypeDropShip(val) {
      if (val == 'DropShip') {
        this.items.forEach(element => {
          if (element) {
            let product_status_inventory =
              element.skuModel.product_status.inventory
            if (
              product_status_inventory !== 'NonStock' &&
              product_status_inventory !== 'Hold' &&
              product_status_inventory !== 'Delete' &&
              product_status_inventory !== 'New'
            ) {
              element.skuModel.product_status.inventory = 'NonStock'
              element.skuModel.product_status.sale = 'Active'
              element.skuModel.other.is_available_stock = true
              element.skuModel.other.has_image = true
            }
          }
        })
      }
    },
    setOFMBarcodeFromVendorBarcode(element) {
      element.skuModel.barcodes.find(
        f => f.type === 'OFM'
      ).barcode = element.skuModel.barcodes.find(
        f => f.type === 'Vendor'
      ).barcode
      if (
        element.skuModel.barcodes.find(f => f.type === 'OFM').barcode !== ''
      ) {
        element.skuModel.other.is_default_barcode = false
      }
    },
    onChangeProductStatusInventory(element,index) {
      console.log(element)
      if (
        this.productStatusInventoryOptions.some(
          f => f.text == element.skuModel.product_status.inventory
        )
      ) {
        this.isAllPreOrder = false
        let ofmStockInventory = this.productStatusInventoryOptions.find(
          f => f.text == element.skuModel.product_status.inventory
        )

        for(var i=0;i<this.items.length;i++){
          // if(i == 0){
          //   if(this.items[i].skuModel.product_status.inventory == 'PreOrder'){
          //     console.log("1")
          //     this.isAllPreOrder = true;
          //   }
          // }
          if(element.skuModel.product_status.inventory == 'PreOrder'){
             console.log("2")
            this.isAllPreOrder = true;
            if(index == 0){
              this.items[i].skuModel.product_status.inventory = ofmStockInventory.text
              this.items[i].skuModel.product_status.sale = ofmStockInventory.product_status_sale
              this.items[i].skuModel.other.is_available_stock = ofmStockInventory.is_available_stock
            }else{
             this.items[i].skuModel.product_status.inventory = ofmStockInventory.text
             this.items[i].skuModel.product_status.sale = ofmStockInventory.product_status_sale
             this.items[i].skuModel.other.is_available_stock = ofmStockInventory.is_available_stock
            }
          }else{
            if(this.items[i].skuModel.product_status.inventory == 'PreOrder'){
              this.items[i].skuModel.product_status.inventory = ""
              this.items[i].skuModel.product_status.sale = ""
              this.items[i].skuModel.other.is_available_stock = ""
            }
          }
        }
        element.skuModel.product_status.inventory = ofmStockInventory.text
        element.skuModel.product_status.sale = ofmStockInventory.product_status_sale
        element.skuModel.other.is_available_stock = ofmStockInventory.is_available_stock
      }
      else{
        element.skuModel.product_status.inventory = ""
        element.skuModel.product_status.sale = ""
        element.skuModel.other.is_available_stock = ""
        console.log(this.items.filter(w=>w.skuModel.product_status.inventory != ""),element.skuModel.product_status.inventory)
        if(!this.items.some(w=>w.skuModel.product_status.inventory != "")){
           console.log("3")
           this.isAllPreOrder = true;
        }
        
      }
      eventBus.$emit('onSetDefault', {type:'Status',value:''})
    },
    onChangeIsDefaultBarcode(isDefault, element) {
      if (isDefault) {
        element.skuModel.barcodes.find(f => f.type === 'OFM').barcode = ''
      }
    },
    onChangeSpecialProduct(isSpecialProduct, element) {
      if (isSpecialProduct) {
        if (this.vendor_type === 'DropShip') {
          element.skuModel.product_status.inventory = 'NonStock'
          element.skuModel.product_status.sale = 'Active'
          element.skuModel.other.is_available_stock = true
          element.skuModel.other.has_image = true
        } else if (this.is_free) {
          element.skuModel.product_status.inventory = 'Free'
          element.skuModel.product_status.sale = 'Active'
          element.skuModel.other.is_available_stock = true
        } else {
          element.skuModel.product_status.inventory = 'Special'
          element.skuModel.product_status.sale = 'Active'
          element.skuModel.other.is_available_stock = true
          element.skuModel.other.has_image = false
        }
        element.skuModel.jda.status = 'I'
      } else {
        if (this.vendor_type === 'DropShip') {
          element.skuModel.product_status.inventory = 'NonStock'
          element.skuModel.product_status.sale = 'Active'
          element.skuModel.other.is_available_stock = true
          element.skuModel.other.has_image = true
        } else if (this.is_free) {
          element.skuModel.product_status.inventory = 'Free'
          element.skuModel.product_status.sale = 'Active'
          element.skuModel.other.is_available_stock = true
        } else {
          element.skuModel.product_status.inventory = ''
          element.skuModel.product_status.sale = ''
        }
      }
    },
    onChangeDefault(isDefault, element, type) {
      if (isDefault) {
        if (type == 'Document' || type == 'All') {
          element.skuModel.product_names.find(
            f => f.type == 'Document'
          ).display_name = {
            th: (
              (this.basicModel
                ? `${
                    this.basicModel.product_names.find(f => f.type == 'Vendor')
                      .display_name.th == ''
                      ? ''
                      : this.basicModel.product_names.find(
                          f => f.type == 'Vendor'
                        ).display_name.th + ' '
                  }${
                    this.basicModel.brand.display_name.th == 'Non-Brand' ||
                    this.basicModel.brand.display_name.th == 'Non-Brand-' ||
                    this.basicModel.brand.display_name.th == ''
                      ? ''
                      : this.basicModel.brand.display_name.th + ' '
                  }${
                    this.basicModel.series.display_name.th.trim() ==
                      'Non-Series' ||
                    this.basicModel.series.display_name.th == ''
                      ? ''
                      : this.basicModel.series.display_name.th + ' '
                  }`
                : '') +
              `${
                element.skuModel.mechanics &&
                element.skuModel.mechanics.length > 1
                  ? `${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'color'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'color'
                          ).value.display_name.th == 'Non-Color'
                          ? ''
                          : 'สี' +
                            element.skuModel.mechanics.find(
                              f => f.collection == 'color'
                            ).value.display_name.th +
                            ' '
                        : ''
                    }${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'size'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'size'
                          ).value.display_name.th
                        : ''
                    }`
                  : ''
              }`
            )
              .trim()
              .substring(0, 55),
            en: (
              (this.basicModel
                ? `${
                    this.basicModel.brand.display_name.en == 'Non-Brand' ||
                    this.basicModel.brand.display_name.en == 'Non-Brand-' ||
                    this.basicModel.brand.display_name.en == ''
                      ? ''
                      : this.basicModel.brand.display_name.en + ' '
                  }${
                    this.basicModel.product_names.find(f => f.type == 'Vendor')
                      .display_name.en == ''
                      ? ''
                      : this.basicModel.product_names.find(
                          f => f.type == 'Vendor'
                        ).display_name.en + ' '
                  }${
                    this.basicModel.series.display_name.en.trim() ==
                      'Non-Series' ||
                    this.basicModel.series.display_name.en == ''
                      ? ''
                      : this.basicModel.series.display_name.en + ' '
                  }`
                : '') +
              `${
                element.skuModel.mechanics &&
                element.skuModel.mechanics.length > 1
                  ? `${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'size'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'size'
                          ).value.display_name.en + ' '
                        : ''
                    }${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'color'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'color'
                          ).value.display_name.en == 'Non-Color'
                          ? ''
                          : element.skuModel.mechanics.find(
                              f => f.collection == 'color'
                            ).value.display_name.en
                        : ''
                    }`
                  : ''
              }`
            )
              .trim()
              .substring(0, 55),
          }
        }
        if (type == 'Online' || type == 'All') {
          element.skuModel.product_names.find(
            f => f.type == 'Online'
          ).display_name = {
            th: (
              (this.basicModel
                ? `${
                    this.basicModel.product_names.find(f => f.type == 'Vendor')
                      .display_name.th == ''
                      ? ''
                      : this.basicModel.product_names.find(
                          f => f.type == 'Vendor'
                        ).display_name.th + ' '
                  }${
                    this.basicModel.brand.display_name.th == 'Non-Brand' ||
                    this.basicModel.brand.display_name.th == 'Non-Brand-' ||
                    this.basicModel.brand.display_name.th == ''
                      ? ''
                      : this.basicModel.brand.display_name.th + ' '
                  }${
                    this.basicModel.series.display_name.th.trim() ==
                      'Non-Series' ||
                    this.basicModel.series.display_name.th == ''
                      ? ''
                      : this.basicModel.series.display_name.th + ' '
                  }`
                : '') +
              `${
                element.skuModel.mechanics &&
                element.skuModel.mechanics.length > 1
                  ? `${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'color'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'color'
                          ).value.display_name.th == 'Non-Color'
                          ? ''
                          : 'สี' +
                            element.skuModel.mechanics.find(
                              f => f.collection == 'color'
                            ).value.display_name.th +
                            ' '
                        : ''
                    }${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'size'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'size'
                          ).value.display_name.th + ' '
                        : ''
                    }${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'unit'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'unit'
                          ).value.display_name.th
                        : ''
                    }`
                  : ''
              }`
            )
              .trim()
              .substring(0, 200),
            en: (
              (this.basicModel
                ? `${
                    this.basicModel.brand.display_name.en == 'Non-Brand' ||
                    this.basicModel.brand.display_name.en == 'Non-Brand-' ||
                    this.basicModel.brand.display_name.en == ''
                      ? ''
                      : this.basicModel.brand.display_name.en + ' '
                  }${
                    this.basicModel.product_names.find(f => f.type == 'Vendor')
                      .display_name.en == ''
                      ? ''
                      : this.basicModel.product_names.find(
                          f => f.type == 'Vendor'
                        ).display_name.en + ' '
                  }${
                    this.basicModel.series.display_name.en.trim() ==
                      'Non-Series' ||
                    this.basicModel.series.display_name.en == ''
                      ? ''
                      : this.basicModel.series.display_name.en + ' '
                  }`
                : '') +
              `${
                element.skuModel.mechanics &&
                element.skuModel.mechanics.length > 1
                  ? `${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'color'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'color'
                          ).value.display_name.en == 'Non-Color'
                          ? ''
                          : element.skuModel.mechanics.find(
                              f => f.collection == 'color'
                            ).value.display_name.en + ' '
                        : ''
                    }${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'size'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'size'
                          ).value.display_name.en + ' '
                        : ''
                    }${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'unit'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'unit'
                          ).value.display_name.en
                        : ''
                    }`
                  : ''
              }`
            )
              .trim()
              .substring(0, 200),
          }
          this.getProductSEONameAsync(
            element.skuModel.product_names.find(f => f.type == 'Online')
              .display_name,
            element
          )
        }
        if (type == 'Inventory' || type == 'All') {
          element.skuModel.product_names.find(
            f => f.type == 'Inventory'
          ).display_name = {
            th: (
              (this.basicModel
                ? `${
                    this.basicModel.product_names.find(f => f.type == 'Vendor')
                      .display_name.th == ''
                      ? ''
                      : this.basicModel.product_names.find(
                          f => f.type == 'Vendor'
                        ).display_name.th + ' '
                  }`
                : '') +
              `${
                element.skuModel.mechanics &&
                element.skuModel.mechanics.length > 1
                  ? `${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'size'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'size'
                          ).value.display_name.th + ' '
                        : ''
                    }${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'color'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'color'
                          ).value.display_name.th == 'Non-Color'
                          ? ''
                          : 'สี' +
                            element.skuModel.mechanics.find(
                              f => f.collection == 'color'
                            ).value.display_name.th +
                            ' '
                        : ''
                    }${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'unit'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'unit'
                          ).value.display_name.th + ' '
                        : ''
                    }`
                  : ''
              }` +
              (this.basicModel
                ? `${
                    this.basicModel.brand.display_name.th == 'Non-Brand' ||
                    this.basicModel.brand.display_name.th == 'Non-Brand-' ||
                    this.basicModel.brand.display_name.th == ''
                      ? ''
                      : this.basicModel.brand.display_name.th + ' '
                  }${
                    this.basicModel.series.display_name.th.trim() ==
                      'Non-Series' ||
                    this.basicModel.series.display_name.th == ''
                      ? ''
                      : this.basicModel.series.display_name.th
                  }`
                : '')
            )
              .trim()
              .substring(0, 200),
            en: (
              (this.basicModel
                ? `${
                    this.basicModel.brand.display_name.en == 'Non-Brand' ||
                    this.basicModel.brand.display_name.en == 'Non-Brand-' ||
                    this.basicModel.brand.display_name.en == ''
                      ? ''
                      : this.basicModel.brand.display_name.en + ' '
                  }${
                    this.basicModel.product_names.find(f => f.type == 'Vendor')
                      .display_name.en == ''
                      ? ''
                      : this.basicModel.product_names.find(
                          f => f.type == 'Vendor'
                        ).display_name.en + ' '
                  }${
                    this.basicModel.series.display_name.en.trim() ==
                      'Non-Series' ||
                    this.basicModel.series.display_name.en == ''
                      ? ''
                      : this.basicModel.series.display_name.en + ' '
                  }`
                : '') +
              `${
                element.skuModel.mechanics &&
                element.skuModel.mechanics.length > 1
                  ? `${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'size'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'size'
                          ).value.display_name.en + ' '
                        : ''
                    }${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'color'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'color'
                          ).value.display_name.en == 'Non-Color'
                          ? ''
                          : element.skuModel.mechanics.find(
                              f => f.collection == 'color'
                            ).value.display_name.en + ' '
                        : ''
                    }${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'unit'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'unit'
                          ).value.display_name.en
                        : ''
                    }`
                  : ''
              }`
            )
              .trim()
              .substring(0, 200),
          }
        }
        if (type == 'Handheld' || type == 'All') {
          element.skuModel.product_names.find(
            f => f.type == 'Handheld'
          ).display_name = {
            th: (
              (this.basicModel
                ? `${
                    this.basicModel.product_names.find(f => f.type == 'Vendor')
                      .display_name.th == ''
                      ? ''
                      : this.basicModel.product_names.find(
                          f => f.type == 'Vendor'
                        ).display_name.th + ' '
                  }${
                    this.basicModel.brand.display_name.th == 'Non-Brand' ||
                    this.basicModel.brand.display_name.th == 'Non-Brand-' ||
                    this.basicModel.brand.display_name.th == ''
                      ? ''
                      : this.basicModel.brand.display_name.th + ' '
                  }${
                    this.basicModel.series.display_name.th.trim() ==
                      'Non-Series' ||
                    this.basicModel.series.display_name.th == ''
                      ? ''
                      : this.basicModel.series.display_name.th + ' '
                  }`
                : '') +
              `${
                element.skuModel.mechanics &&
                element.skuModel.mechanics.length > 1
                  ? `${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'color'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'color'
                          ).value.display_name.th == 'Non-Color'
                          ? ''
                          : 'สี' +
                            element.skuModel.mechanics.find(
                              f => f.collection == 'color'
                            ).value.display_name.th +
                            ' '
                        : ''
                    }${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'size'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'size'
                          ).value.display_name.th
                        : ''
                    }`
                  : ''
              }`
            )
              .trim()
              .substring(0, 20),
            en: (
              (this.basicModel
                ? `${
                    this.basicModel.brand.display_name.en == 'Non-Brand' ||
                    this.basicModel.brand.display_name.en == 'Non-Brand-' ||
                    this.basicModel.brand.display_name.en == ''
                      ? ''
                      : this.basicModel.brand.display_name.en + ' '
                  }${
                    this.basicModel.product_names.find(f => f.type == 'Vendor')
                      .display_name.en == ''
                      ? ''
                      : this.basicModel.product_names.find(
                          f => f.type == 'Vendor'
                        ).display_name.en + ' '
                  }${
                    this.basicModel.series.display_name.en.trim() ==
                      'Non-Series' ||
                    this.basicModel.series.display_name.en == ''
                      ? ''
                      : this.basicModel.series.display_name.en + ' '
                  }`
                : '') +
              `${
                element.skuModel.mechanics &&
                element.skuModel.mechanics.length > 1
                  ? `${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'size'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'size'
                          ).value.display_name.en + ' '
                        : ''
                    }${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'color'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'color'
                          ).value.display_name.en == 'Non-Color'
                          ? ''
                          : element.skuModel.mechanics.find(
                              f => f.collection == 'color'
                            ).value.display_name.en + ' '
                        : ''
                    }${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'unit'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'unit'
                          ).value.display_name.en
                        : ''
                    }`
                  : ''
              }`
            )
              .trim()
              .substring(0, 20),
          }
        }
        if (type == 'JDA' || type == 'All') {
          element.skuModel.product_names.find(
            f => f.type == 'JDA'
          ).display_name = {
            th: (
              (this.basicModel
                ? `${
                    this.basicModel.product_names.find(f => f.type == 'Vendor')
                      .display_name.th == ''
                      ? ''
                      : this.basicModel.product_names.find(
                          f => f.type == 'Vendor'
                        ).display_name.th + ' '
                  }${
                    this.basicModel.brand.display_name.th == 'Non-Brand' ||
                    this.basicModel.brand.display_name.th == 'Non-Brand-' ||
                    this.basicModel.brand.display_name.th == ''
                      ? ''
                      : this.basicModel.brand.display_name.th + ' '
                  }${
                    this.basicModel.series.display_name.th.trim() ==
                      'Non-Series' ||
                    this.basicModel.series.display_name.th == ''
                      ? ''
                      : this.basicModel.series.display_name.th + ' '
                  }`
                : '') +
              `${
                element.skuModel.mechanics &&
                element.skuModel.mechanics.length > 1
                  ? `${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'color'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'color'
                          ).value.display_name.th == 'Non-Color'
                          ? ''
                          : 'สี' +
                            element.skuModel.mechanics.find(
                              f => f.collection == 'color'
                            ).value.display_name.th +
                            ' '
                        : ''
                    }${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'size'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'size'
                          ).value.display_name.th
                        : ''
                    }`
                  : ''
              }`
            )
              .trim()
              .substring(0, 30),
            en: (
              (this.basicModel
                ? `${
                    this.basicModel.brand.display_name.en == 'Non-Brand' ||
                    this.basicModel.brand.display_name.en == 'Non-Brand-' ||
                    this.basicModel.brand.display_name.en == ''
                      ? ''
                      : this.basicModel.brand.display_name.en + ' '
                  }${
                    this.basicModel.product_names.find(f => f.type == 'Vendor')
                      .display_name.en == ''
                      ? ''
                      : this.basicModel.product_names.find(
                          f => f.type == 'Vendor'
                        ).display_name.en + ' '
                  }${
                    this.basicModel.series.display_name.en.trim() ==
                      'Non-Series' ||
                    this.basicModel.series.display_name.en == ''
                      ? ''
                      : this.basicModel.series.display_name.en + ' '
                  }`
                : '') +
              `${
                element.skuModel.mechanics &&
                element.skuModel.mechanics.length > 1
                  ? `${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'size'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'size'
                          ).value.display_name.en + ' '
                        : ''
                    }${
                      element.skuModel.mechanics.some(
                        f => f.collection == 'color'
                      )
                        ? element.skuModel.mechanics.find(
                            f => f.collection == 'color'
                          ).value.display_name.en == 'Non-Color'
                          ? ''
                          : element.skuModel.mechanics.find(
                              f => f.collection == 'color'
                            ).value.display_name.en
                        : ''
                    }`
                  : ''
              }`
            )
              .trim()
              .substring(0, 30),
          }
        }
      }
    },
    async getProductSEONameAsync(name, element) {
      if (name && name.th !== '') {
        let params = new URLSearchParams()
        params.append('name', name.th)
        let result = await productService.getProductSEONameAsync(params)
        if (result.status === 200) {
          element.skuModel.meta.seo_name.th = result.data
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          console.log(result.response.data.message)
        }
      }
      if (name && name.en !== '') {
        let params = new URLSearchParams()
        params.append('name', name.en)
        let result = await productService.getProductSEONameAsync(params)
        if (result.status === 200) {
          element.skuModel.meta.seo_name.en = result.data
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          console.log(result.response.data.message)
        }
      }
    },
    onClickCheckboxMeta(isDefault, element, field, language) {
      if (isDefault) {
        if (field == 'title_tag') {
          if (language == 'th') {
            let productNameTxt = element.skuModel.product_names.find(
              f => f.type == 'Online'
            ).display_name.th
            element.skuModel.meta.title_tag.th =
              (!productNameTxt || productNameTxt == ''
                ? ''
                : `${productNameTxt} | `) 
          } else if (language == 'en') {
            let productNameTxt = element.skuModel.product_names.find(
              f => f.type == 'Online'
            ).display_name.en
            element.skuModel.meta.title_tag.en =
              (!productNameTxt || productNameTxt == ''
                ? ''
                : `${productNameTxt} | `)
          }
        } else if (field == 'description_tag') {
          if (language == 'th') {
            let productNameTxt = element.skuModel.product_names.find(
              f => f.type == 'Online'
            ).display_name.th
            element.skuModel.meta.description_tag.th =
              (!productNameTxt || productNameTxt == ''
                ? ''
                : `ช้อป ${productNameTxt} `)
          } else if (language == 'en') {
            let productNameTxt = element.skuModel.product_names.find(
              f => f.type == 'Online'
            ).display_name.en
            element.skuModel.meta.description_tag.en =
              (!productNameTxt || productNameTxt == ''
                ? ''
                : `${productNameTxt} `) 
          }
        }
      }
      // else {
      //   if (field == 'title_tag') {
      //     if (language == 'th') {
      //       element.skuModel.meta.title_tag.th = ''
      //     } else if (language == 'en') {
      //       element.skuModel.meta.title_tag.en = ''
      //     }
      //   } else if (field == 'description_tag') {
      //     if (language == 'th') {
      //       element.skuModel.meta.description_tag.th = ''
      //     } else if (language == 'en') {
      //       element.skuModel.meta.description_tag.en = ''
      //     }
      //   }
      // }
    },
    onRetailPriceChange(val) {
      if (
        this.userInfo.user_type === 'Vendor' &&
        this.vendor_type === 'OFMStock'
      ) {
        // val.skuModel.prices.find(
        //   f => f.type == 'SalePrice'
        // ).include_vat = val.skuModel.prices.find(
        //   f => f.type == 'RetailPrice'
        // ).include_vat

        this.onCalculatePrice(val)
      }
    },
    onCalculatePrice(val) {
      setTimeout(() => {
        this.calculatePrice(val)
      }, 500)
      // this.$nextTick(() => {
      //   this.calculatePrice(val)
      // })
    },
    calculatePrice(val) {
      let sale_price_include_vat = val.skuModel.prices.some(
        f => f.type == 'SalePrice'
      )
        ? Number(
            val.skuModel.prices.find(f => f.type == 'SalePrice').include_vat
          ).toFixed(2)
        : 0
      if (val.skuModel.other.is_vat) {
        val.skuModel.prices.find(
          f => f.type == 'SalePrice'
        ).exclude_vat = Number(
          sale_price_include_vat -
            Number((sale_price_include_vat * 7) / 107).toFixed(2)
        ).toFixed(2)
      } else {
        val.skuModel.prices.find(
          f => f.type == 'SalePrice'
        ).exclude_vat = Number(sale_price_include_vat).toFixed(2)
      }

      let sale_price_exclude_vat = val.skuModel.prices.some(
        f => f.type == 'SalePrice'
      )
        ? Number(
            val.skuModel.prices.find(f => f.type == 'SalePrice').exclude_vat
          ).toFixed(2)
        : 0

      //มีเฉพาะใน UI ส่วน APis ไม่ต้องคำนวณใหม่
      if (this.vendor_type !== 'OFMStock') {
        val.skuModel.prices.find(f => f.type == 'Cost').exclude_vat = Number(
          sale_price_exclude_vat -
            (sale_price_exclude_vat *
              Number(val.skuModel.other.commission_rate)) /
              100
        ).toFixed(2)
      }
      //-------------------

      // val.skuModel.other.mr_point = parseInt(sale_price_include_vat * 10) //ปัดลง
      val.skuModel.other.mr_point = Math.round(
        parseFloat(sale_price_include_vat * 10)
      ) //ปัดขึ้น

      if (val.skuModel.unit.ratio !== 0) {
        let costPerRatio = Number(
          val.skuModel.prices.find(f => f.type == 'Cost').exclude_vat /
            val.skuModel.unit.ratio
        )
        let discountPerUnit = Number(
          (costPerRatio * val.skuModel.other.discount_rate) / 100
        ).toFixed(2)
        let discountBill = Number(
          ((costPerRatio - discountPerUnit) * this.discount_rate_1) / 100
        ).toFixed(2)
        val.skuModel.gross_profit.cost_of_sale = Number(
          costPerRatio - discountPerUnit - discountBill
        ).toFixed(2)
      }

      val.skuModel.gross_profit.gp_amount = Number(
        sale_price_exclude_vat - val.skuModel.gross_profit.cost_of_sale
      ).toFixed(2)

      val.skuModel.gross_profit.gp_rate =
        sale_price_include_vat && sale_price_include_vat > 0
          ? Number(
              ((Number(sale_price_exclude_vat) -
                Number(val.skuModel.gross_profit.cost_of_sale)) /
                Number(sale_price_exclude_vat)) *
                100
            ).toFixed(2)
          : 0.0
      val.skuModel.gross_profit.isGPBelow5Percent =
        val.skuModel.gross_profit.gp_rate < 5.0 ? true : false

      val.skuModel.prices.find(f => f.type == 'Cost').include_vat = val.skuModel
        .other.is_vat
        ? Number(
            Number(
              val.skuModel.prices.find(f => f.type == 'Cost').exclude_vat
            ) +
              Number(
                (Number(
                  val.skuModel.prices.find(f => f.type == 'Cost').exclude_vat
                ) *
                  Number(this.vat_rate)) /
                  100
              )
          ).toFixed(2)
        : Number(
            val.skuModel.prices.find(f => f.type == 'Cost').exclude_vat
          ).toFixed(2)
    },
    reloadPercent(row, index) {
      if (
        this.dataPermissions.find(f => f.name === 'skus').isEditable === true
      ) {
        row.toggleDetails()
        setTimeout(() => {
          this.onUpdate(row.item, index)
          setTimeout(() => {
            setTimeout(function() {
              document.getElementById('row-product-' + index).scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }, 300)
            row.item._showDetails = false
          }, 500)
        }, 1000)
      }
    },
    onClickMore(row, index) {
      row.toggleDetails()
      this.SET_NAV_PRODUCT_DETAIL_COLLAPSE_STATE({
        index: index + 1,
        collapseState: !row.detailsShowing,
      })
      this.$nextTick(() => {
        if (this.$refs[`componentForm_${index}`]) {
          this.$refs[`componentForm_${index}`].validate()
        }
      })
      this.refIndex = index
    },
    async onUpdate(item, index, isHideDetail = true) {
      await this.onCalculatePrice(item)
      //Set default values
      if (
        item.skuModel.gross_profit.gp_standard === undefined ||
        item.skuModel.gross_profit.gp_standard === null ||
        item.skuModel.gross_profit.gp_standard === ''
      ) {
        item.skuModel.gross_profit.gp_standard = 0
      }

      //Update SEO Name by Product Name Type Online
      this.getProductSEONameAsync(
        item.skuModel.product_names.find(f => f.type == 'Online').display_name,
        item
      )
      if (
        this.dataPermissions.find(f => f.name === 'skus').isEditable === false
      ) {
        this.items[index].validateState = true
        this.items[index].successRate = 100
        setTimeout(function() {
          document.getElementById('row-product-' + index).scrollIntoView({
            block: 'center',
            behavior: 'smooth',
          })
        }, 300)

        if (isHideDetail) {
          setTimeout(() => {
            item._showDetails = false
          }, 500)
        }

        this.modelChanged()
        return
      }

      this.modelChanged()

      this.$refs[`componentForm_${index}`].validate().then(async result => {
        if (result) {
          if (this.userInfo.user_type === 'Operator') {
            //-------------------------------------------------------
            //Set default number if null
            if (
              item.skuModel.prices.find(x => x.type === 'RetailPrice')
                .include_vat === null ||
              item.skuModel.prices.find(x => x.type === 'RetailPrice')
                .include_vat === ''
            ) {
              item.skuModel.prices.find(
                x => x.type === 'RetailPrice'
              ).include_vat = 0.0
            }
            if (
              item.skuModel.prices.find(x => x.type === 'SalePrice')
                .include_vat === null ||
              item.skuModel.prices.find(x => x.type === 'SalePrice')
                .include_vat === ''
            ) {
              item.skuModel.prices.find(
                x => x.type === 'SalePrice'
              ).include_vat = 0.0
            }
            if (
              item.skuModel.gross_profit.cost_of_sale === null ||
              item.skuModel.gross_profit.cost_of_sale === ''
            ) {
              item.skuModel.gross_profit.cost_of_sale = 0.0
            }
            if (
              item.skuModel.gross_profit.gp_rate === null ||
              item.skuModel.gross_profit.gp_rate === ''
            ) {
              item.skuModel.gross_profit.gp_rate = 0.0
            }

            //----------------------------------------------------------------
            const retailPrice = Number(
              item.skuModel.prices.find(x => x.type === 'RetailPrice')
                .include_vat
            ).toFixed(2)
            // const costOfSale = Number(
            //   item.skuModel.gross_profit.cost_of_sale * 1.07
            // ).toFixed(2)

              console.log('item.skuModel.other.is_vat :>> ', item.skuModel.other.is_vat);
              const costOfSale = item.skuModel.other.is_vat ? 
              Number(
                item.skuModel.gross_profit.cost_of_sale * 1.07
              ).toFixed(2)
              :
              Number(
                item.skuModel.gross_profit.cost_of_sale
              ).toFixed(2)
                console.log('retailPrice :>> ', retailPrice);
                console.log('costOfSale :>> ', costOfSale);


            if (
              item.skuModel.sku_codes.find(f => f.type == 'CPC').code === ''
            ) {
              this.$utils.notification('error', `กรุณาเลือก JDA Category`, 2000)
              return
            } else if (Number(retailPrice) < Number(costOfSale)) {
              this.$utils.notification(
                'error',
                `Full Price ห้ามต่ำกว่าราคาทุน`,
                2000
              )
              return
            } else if (
              this.is_free === false &&
              Number(
                item.skuModel.prices.find(x => x.type === 'RetailPrice')
                  .include_vat
              ) <
                Number(
                  item.skuModel.prices.find(x => x.type === 'SalePrice')
                    .include_vat
                )
            ) {
              this.$utils.notification(
                'error',
                `Full Price ห้ามต่ำกว่าราคาขาย InVat`,
                2000
              )
              return
            } else if (
              Number(item.skuModel.gross_profit.gp_rate) < 10.0 &&
              item.skuModel.other.is_best_deal === false &&
              this.is_best_deal === false
            ) {
              await this.$utils
                .confirmAlertDisplay(
                  `GP Rate ต่ำกว่า 10% ต้องการให้ติด Best Deal หรือไม่`,
                  ''
                )
                .then(result => {
                  if (result) {
                    item.skuModel.other.is_best_deal = true
                  }
                })
            }
          }
          //Set commission_rate_type        
          this.items[index].skuModel.other.commission_rate_type = this.basicModel.commission_rate_type
          
          this.items[index].validateState = true
          this.items[index].successRate = 100
          setTimeout(function() {
            document.getElementById('row-product-' + index).scrollIntoView({
              block: 'center',
              behavior: 'smooth',
            })
          }, 300)
          setTimeout(() => {
            item._showDetails = false
          }, 500)
        } else {
          //--------- คำนวณ % เสร็จสิ้นของ SKU Row--------------------------

          let objError = this.$refs[`componentForm_${index}`].errors
          let totalValidate = Object.keys(objError).length
          let totalError = 0
          let errorList = []
          Object.keys(objError).forEach(element => {
            if (objError[element].length > 0) {
              ++totalError
              errorList.push(element)
            }
          })
          let successRate = Math.ceil(100 - (totalError / totalValidate) * 100)
          this.items[index].successRate = successRate

          //--------------------------------------------------------------

          this.items[index].validateState = false
          setTimeout(function() {
            document.getElementById(`${errorList[0]}_${index}`).scrollIntoView({
              block: 'center',
              behavior: 'smooth',
            })
          }, 300)
        }
      })
    },
    genHexString(len) {
      const hex = '0123456789abcdef'
      let output = ''
      for (let i = 0; i < len; ++i) {
        output += hex.charAt(Math.floor(Math.random() * hex.length))
      }
      return output
    },
    setCollapseRowDetail(index, collapseState) {
      this.items[index]._showDetails = collapseState
    },
    scrollToRef(refName) {
      // console.log(this.$refs)
      let element = this.$refs[refName] || undefined
      if (element) {
        let offsetTop = 0
        //  console.log('element', element)
        while (element) {
          // console.log('offsetTop', element.offsetTop)
          if (element.offsetTop) {
            offsetTop += element.offsetTop
          }
          element = element.offsetParent
        }
        var top = offsetTop - 150
        // console.log(refName, ':', top)
        window.scroll({
          behavior: 'smooth',
          top: top,
        })
      }
    },
    handleScroll() {
      var scrollRef = [
        'componentForm_' + this.refIndex + '_SKUCode',
        'componentForm_' + this.refIndex + '_SKUInformation',
        'componentForm_' + this.refIndex + '_ProductName',
        'componentForm_' + this.refIndex + '_Price',
        'componentForm_' + this.refIndex + '_Quantity',
        'componentForm_' + this.refIndex + '_Status',
        'componentForm_' + this.refIndex + '_Image',
        'componentForm_' + this.refIndex + '_Seo',
        'componentForm_' + this.refIndex + '_InventoryInformation',
        'componentForm_' + this.refIndex + '_JDAInformation',
        'componentForm_' + this.refIndex + '_Substitute',
      ]
      if (this.$refs['componentForm_' + this.refIndex]) {
        scrollRef.forEach(element => {
          if (
            this.$refs[element].getBoundingClientRect().top -
              155 +
              this.$refs[element].clientHeight >
              0 &&
            this.$refs[element].getBoundingClientRect().top -
              155 +
              this.$refs[element].clientHeight <
              this.$refs[element].clientHeight
          ) {
            this.refActiveDetail = element
          }
        })
      }
    },
  },
}
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}
</style>